function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _CONSOLE_METHOD_MAP;
var _excluded = ["children"],
  _excluded2 = ["behavior", "align"],
  _excluded3 = ["done", "behavior", "align", "calculateViewLocation"],
  _excluded4 = ["listState", "topItemsIndexes"],
  _excluded5 = ["style", "children"],
  _excluded6 = ["style", "children"];
function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure " + obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import React from "react";
import ReactDOM from "react-dom";
var PUBLISH = 0;
var SUBSCRIBE = 1;
var RESET = 2;
var VALUE = 4;
function compose(a, b) {
  return function (arg) {
    return a(b(arg));
  };
}
function thrush(arg, proc) {
  return proc(arg);
}
function curry2to1(proc, arg1) {
  return function (arg2) {
    return proc(arg1, arg2);
  };
}
function curry1to0(proc, arg) {
  return function () {
    return proc(arg);
  };
}
function tap(arg, proc) {
  proc(arg);
  return arg;
}
function tup() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return args;
}
function call(proc) {
  proc();
}
function always(value) {
  return function () {
    return value;
  };
}
function joinProc() {
  for (var _len2 = arguments.length, procs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    procs[_key2] = arguments[_key2];
  }
  return function () {
    procs.map(call);
  };
}
function isDefined(arg) {
  return arg !== void 0;
}
function noop() {}
function subscribe(emitter, subscription) {
  return emitter(SUBSCRIBE, subscription);
}
function publish(publisher, value) {
  publisher(PUBLISH, value);
}
function reset(emitter) {
  emitter(RESET);
}
function getValue(depot) {
  return depot(VALUE);
}
function connect(emitter, publisher) {
  return subscribe(emitter, curry2to1(publisher, PUBLISH));
}
function handleNext(emitter, subscription) {
  var unsub = emitter(SUBSCRIBE, function (value) {
    unsub();
    subscription(value);
  });
  return unsub;
}
function stream() {
  var subscriptions = [];
  return function (action, arg) {
    switch (action) {
      case RESET:
        subscriptions.splice(0, subscriptions.length);
        return;
      case SUBSCRIBE:
        subscriptions.push(arg);
        return function () {
          var indexOf = subscriptions.indexOf(arg);
          if (indexOf > -1) {
            subscriptions.splice(indexOf, 1);
          }
        };
      case PUBLISH:
        subscriptions.slice().forEach(function (subscription) {
          subscription(arg);
        });
        return;
      default:
        throw new Error("unrecognized action ".concat(action));
    }
  };
}
function statefulStream(initial) {
  var value = initial;
  var innerSubject = stream();
  return function (action, arg) {
    switch (action) {
      case SUBSCRIBE:
        var subscription = arg;
        subscription(value);
        break;
      case PUBLISH:
        value = arg;
        break;
      case VALUE:
        return value;
    }
    return innerSubject(action, arg);
  };
}
function eventHandler(emitter) {
  var unsub;
  var currentSubscription;
  var cleanup = function cleanup() {
    return unsub && unsub();
  };
  return function (action, subscription) {
    switch (action) {
      case SUBSCRIBE:
        if (subscription) {
          if (currentSubscription === subscription) {
            return;
          }
          cleanup();
          currentSubscription = subscription;
          unsub = subscribe(emitter, subscription);
          return unsub;
        } else {
          cleanup();
          return noop;
        }
      case RESET:
        cleanup();
        currentSubscription = null;
        return;
      default:
        throw new Error("unrecognized action ".concat(action));
    }
  };
}
function streamFromEmitter(emitter) {
  return tap(stream(), function (stream2) {
    return connect(emitter, stream2);
  });
}
function statefulStreamFromEmitter(emitter, initial) {
  return tap(statefulStream(initial), function (stream2) {
    return connect(emitter, stream2);
  });
}
function combineOperators() {
  for (var _len3 = arguments.length, operators = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    operators[_key3] = arguments[_key3];
  }
  return function (subscriber) {
    return operators.reduceRight(thrush, subscriber);
  };
}
function pipe(source) {
  for (var _len4 = arguments.length, operators = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    operators[_key4 - 1] = arguments[_key4];
  }
  var project = combineOperators.apply(void 0, operators);
  return function (action, subscription) {
    switch (action) {
      case SUBSCRIBE:
        return subscribe(source, project(subscription));
      case RESET:
        reset(source);
        return;
    }
  };
}
function defaultComparator(previous, next) {
  return previous === next;
}
function distinctUntilChanged() {
  var comparator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultComparator;
  var current;
  return function (done) {
    return function (next) {
      if (!comparator(current, next)) {
        current = next;
        done(next);
      }
    };
  };
}
function filter(predicate) {
  return function (done) {
    return function (value) {
      predicate(value) && done(value);
    };
  };
}
function map(project) {
  return function (done) {
    return compose(done, project);
  };
}
function mapTo(value) {
  return function (done) {
    return function () {
      return done(value);
    };
  };
}
function scan(scanner, initial) {
  return function (done) {
    return function (value) {
      return done(initial = scanner(initial, value));
    };
  };
}
function skip(times) {
  return function (done) {
    return function (value) {
      times > 0 ? times-- : done(value);
    };
  };
}
function throttleTime(interval) {
  var currentValue = null;
  var timeout;
  return function (done) {
    return function (value) {
      currentValue = value;
      if (timeout) {
        return;
      }
      timeout = setTimeout(function () {
        timeout = void 0;
        done(currentValue);
      }, interval);
    };
  };
}
function debounceTime(interval) {
  var currentValue;
  var timeout;
  return function (done) {
    return function (value) {
      currentValue = value;
      if (timeout) {
        clearTimeout(timeout);
      }
      timeout = setTimeout(function () {
        done(currentValue);
      }, interval);
    };
  };
}
function withLatestFrom() {
  for (var _len5 = arguments.length, sources = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    sources[_key5] = arguments[_key5];
  }
  var values = new Array(sources.length);
  var called = 0;
  var pendingCall = null;
  var allCalled = Math.pow(2, sources.length) - 1;
  sources.forEach(function (source, index) {
    var bit = Math.pow(2, index);
    subscribe(source, function (value) {
      var prevCalled = called;
      called = called | bit;
      values[index] = value;
      if (prevCalled !== allCalled && called === allCalled && pendingCall) {
        pendingCall();
        pendingCall = null;
      }
    });
  });
  return function (done) {
    return function (value) {
      var call2 = function call2() {
        return done([value].concat(values));
      };
      if (called === allCalled) {
        call2();
      } else {
        pendingCall = call2;
      }
    };
  };
}
function merge() {
  for (var _len6 = arguments.length, sources = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
    sources[_key6] = arguments[_key6];
  }
  return function (action, subscription) {
    switch (action) {
      case SUBSCRIBE:
        return joinProc.apply(void 0, _toConsumableArray(sources.map(function (source) {
          return subscribe(source, subscription);
        })));
      case RESET:
        return;
      default:
        throw new Error("unrecognized action ".concat(action));
    }
  };
}
function duc(source) {
  var comparator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultComparator;
  return pipe(source, distinctUntilChanged(comparator));
}
function combineLatest() {
  var innerSubject = stream();
  for (var _len7 = arguments.length, emitters = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
    emitters[_key7] = arguments[_key7];
  }
  var values = new Array(emitters.length);
  var called = 0;
  var allCalled = Math.pow(2, emitters.length) - 1;
  emitters.forEach(function (source, index) {
    var bit = Math.pow(2, index);
    subscribe(source, function (value) {
      values[index] = value;
      called = called | bit;
      if (called === allCalled) {
        publish(innerSubject, values);
      }
    });
  });
  return function (action, subscription) {
    switch (action) {
      case SUBSCRIBE:
        if (called === allCalled) {
          subscription(values);
        }
        return subscribe(innerSubject, subscription);
      case RESET:
        return reset(innerSubject);
      default:
        throw new Error("unrecognized action ".concat(action));
    }
  };
}
function system(constructor) {
  var dependencies = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
      singleton: true
    },
    singleton = _ref.singleton;
  return {
    id: id(),
    constructor: constructor,
    dependencies: dependencies,
    singleton: singleton
  };
}
var id = function id() {
  return Symbol();
};
function init(systemSpec) {
  var singletons = /* @__PURE__ */new Map();
  var _init = function _init(_ref2) {
    var id2 = _ref2.id,
      constructor = _ref2.constructor,
      dependencies = _ref2.dependencies,
      singleton = _ref2.singleton;
    if (singleton && singletons.has(id2)) {
      return singletons.get(id2);
    }
    var system2 = constructor(dependencies.map(function (e) {
      return _init(e);
    }));
    if (singleton) {
      singletons.set(id2, system2);
    }
    return system2;
  };
  return _init(systemSpec);
}
function omit(keys, obj) {
  var result = {};
  var index = {};
  var idx = 0;
  var len = keys.length;
  while (idx < len) {
    index[keys[idx]] = 1;
    idx += 1;
  }
  for (var prop in obj) {
    if (!index.hasOwnProperty(prop)) {
      result[prop] = obj[prop];
    }
  }
  return result;
}
var useIsomorphicLayoutEffect$2 = typeof document !== "undefined" ? React.useLayoutEffect : React.useEffect;
function systemToComponent(systemSpec, map2, Root) {
  var requiredPropNames = Object.keys(map2.required || {});
  var optionalPropNames = Object.keys(map2.optional || {});
  var methodNames = Object.keys(map2.methods || {});
  var eventNames = Object.keys(map2.events || {});
  var Context = /*#__PURE__*/React.createContext({});
  function applyPropsToSystem(system2, props) {
    if (system2["propsReady"]) {
      publish(system2["propsReady"], false);
    }
    for (var _i = 0, _requiredPropNames = requiredPropNames; _i < _requiredPropNames.length; _i++) {
      var requiredPropName = _requiredPropNames[_i];
      var stream2 = system2[map2.required[requiredPropName]];
      publish(stream2, props[requiredPropName]);
    }
    for (var _i2 = 0, _optionalPropNames = optionalPropNames; _i2 < _optionalPropNames.length; _i2++) {
      var optionalPropName = _optionalPropNames[_i2];
      if (optionalPropName in props) {
        var _stream = system2[map2.optional[optionalPropName]];
        publish(_stream, props[optionalPropName]);
      }
    }
    if (system2["propsReady"]) {
      publish(system2["propsReady"], true);
    }
  }
  function buildMethods(system2) {
    return methodNames.reduce(function (acc, methodName) {
      acc[methodName] = function (value) {
        var stream2 = system2[map2.methods[methodName]];
        publish(stream2, value);
      };
      return acc;
    }, {});
  }
  function buildEventHandlers(system2) {
    return eventNames.reduce(function (handlers, eventName) {
      handlers[eventName] = eventHandler(system2[map2.events[eventName]]);
      return handlers;
    }, {});
  }
  var Component = /*#__PURE__*/React.forwardRef(function (propsWithChildren, ref) {
    var children = propsWithChildren.children,
      props = _objectWithoutProperties(propsWithChildren, _excluded);
    var _React$useState = React.useState(function () {
        return tap(init(systemSpec), function (system22) {
          return applyPropsToSystem(system22, props);
        });
      }),
      _React$useState2 = _slicedToArray(_React$useState, 1),
      system2 = _React$useState2[0];
    var _React$useState3 = React.useState(curry1to0(buildEventHandlers, system2)),
      _React$useState4 = _slicedToArray(_React$useState3, 1),
      handlers = _React$useState4[0];
    useIsomorphicLayoutEffect$2(function () {
      for (var _i3 = 0, _eventNames = eventNames; _i3 < _eventNames.length; _i3++) {
        var eventName = _eventNames[_i3];
        if (eventName in props) {
          subscribe(handlers[eventName], props[eventName]);
        }
      }
      return function () {
        Object.values(handlers).map(reset);
      };
    }, [props, handlers, system2]);
    useIsomorphicLayoutEffect$2(function () {
      applyPropsToSystem(system2, props);
    });
    React.useImperativeHandle(ref, always(buildMethods(system2)));
    return /*#__PURE__*/React.createElement(Context.Provider, {
      value: system2
    }, Root ? /*#__PURE__*/React.createElement(Root, omit([].concat(requiredPropNames, optionalPropNames, eventNames), props), children) : children);
  });
  var usePublisher2 = function usePublisher2(key) {
    return React.useCallback(curry2to1(publish, React.useContext(Context)[key]), [key]);
  };
  var useEmitterValue2 = function useEmitterValue2(key) {
    var system2 = React.useContext(Context);
    var source = system2[key];
    var _React$useState5 = React.useState(curry1to0(getValue, source)),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      value = _React$useState6[0],
      setValue = _React$useState6[1];
    useIsomorphicLayoutEffect$2(function () {
      return subscribe(source, function (next) {
        if (next !== value) {
          setValue(always(next));
        }
      });
    }, [source, value]);
    return value;
  };
  var useEmitter2 = function useEmitter2(key, callback) {
    var context = React.useContext(Context);
    var source = context[key];
    useIsomorphicLayoutEffect$2(function () {
      return subscribe(source, callback);
    }, [callback, source]);
  };
  return {
    Component: Component,
    usePublisher: usePublisher2,
    useEmitterValue: useEmitterValue2,
    useEmitter: useEmitter2
  };
}
var useIsomorphicLayoutEffect = typeof document !== "undefined" ? React.useLayoutEffect : React.useEffect;
var useIsomorphicLayoutEffect$1 = useIsomorphicLayoutEffect;
var LogLevel = /* @__PURE__ */function (LogLevel2) {
  LogLevel2[LogLevel2["DEBUG"] = 0] = "DEBUG";
  LogLevel2[LogLevel2["INFO"] = 1] = "INFO";
  LogLevel2[LogLevel2["WARN"] = 2] = "WARN";
  LogLevel2[LogLevel2["ERROR"] = 3] = "ERROR";
  return LogLevel2;
}(LogLevel || {});
var CONSOLE_METHOD_MAP = (_CONSOLE_METHOD_MAP = {}, _defineProperty(_CONSOLE_METHOD_MAP, 0
/* DEBUG */, "debug"), _defineProperty(_CONSOLE_METHOD_MAP, 1
/* INFO */, "log"), _defineProperty(_CONSOLE_METHOD_MAP, 2
/* WARN */, "warn"), _defineProperty(_CONSOLE_METHOD_MAP, 3
/* ERROR */, "error"), _CONSOLE_METHOD_MAP);
var getGlobalThis = function getGlobalThis() {
  return typeof globalThis === "undefined" ? window : globalThis;
};
var loggerSystem = system(function () {
  var logLevel = statefulStream(3
  /* ERROR */);

  var log = statefulStream(function (label, message) {
    var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var _a;
    var currentLevel = (_a = getGlobalThis()["VIRTUOSO_LOG_LEVEL"]) != null ? _a : getValue(logLevel);
    if (level >= currentLevel) {
      console[CONSOLE_METHOD_MAP[level]]("%creact-virtuoso: %c%s %o", "color: #0253b3; font-weight: bold", "color: initial", label, message);
    }
  });
  return {
    log: log,
    logLevel: logLevel
  };
}, [], {
  singleton: true
});
function useSizeWithElRef(callback) {
  var enabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var ref = React.useRef(null);
  var callbackRef = function callbackRef(_el) {};
  if (typeof ResizeObserver !== "undefined") {
    var observer = React.useMemo(function () {
      return new ResizeObserver(function (entries) {
        var element = entries[0].target;
        if (element.offsetParent !== null) {
          callback(element);
        }
      });
    }, [callback]);
    callbackRef = function callbackRef(elRef) {
      if (elRef && enabled) {
        observer.observe(elRef);
        ref.current = elRef;
      } else {
        if (ref.current) {
          observer.unobserve(ref.current);
        }
        ref.current = null;
      }
    };
  }
  return {
    ref: ref,
    callbackRef: callbackRef
  };
}
function useSize(callback) {
  var enabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return useSizeWithElRef(callback, enabled).callbackRef;
}
function useChangedListContentsSizes(callback, itemSize, enabled, scrollContainerStateCallback, log, gap, customScrollParent) {
  var memoedCallback = React.useCallback(function (el) {
    var ranges = getChangedChildSizes(el.children, itemSize, "offsetHeight", log);
    var scrollableElement = el.parentElement;
    while (!scrollableElement.dataset["virtuosoScroller"]) {
      scrollableElement = scrollableElement.parentElement;
    }
    var windowScrolling = scrollableElement.lastElementChild.dataset["viewportType"] === "window";
    var scrollTop = customScrollParent ? customScrollParent.scrollTop : windowScrolling ? window.pageYOffset || document.documentElement.scrollTop : scrollableElement.scrollTop;
    var scrollHeight = customScrollParent ? customScrollParent.scrollHeight : windowScrolling ? document.documentElement.scrollHeight : scrollableElement.scrollHeight;
    var viewportHeight = customScrollParent ? customScrollParent.offsetHeight : windowScrolling ? window.innerHeight : scrollableElement.offsetHeight;
    scrollContainerStateCallback({
      scrollTop: Math.max(scrollTop, 0),
      scrollHeight: scrollHeight,
      viewportHeight: viewportHeight
    });
    gap == null ? void 0 : gap(resolveGapValue$1("row-gap", getComputedStyle(el).rowGap, log));
    if (ranges !== null) {
      callback(ranges);
    }
  }, [callback, itemSize, log, gap, customScrollParent, scrollContainerStateCallback]);
  return useSizeWithElRef(memoedCallback, enabled);
}
function getChangedChildSizes(children, itemSize, field, log) {
  var length = children.length;
  if (length === 0) {
    return null;
  }
  var results = [];
  for (var i = 0; i < length; i++) {
    var child = children.item(i);
    if (!child || child.dataset.index === void 0) {
      continue;
    }
    var index = parseInt(child.dataset.index);
    var knownSize = parseFloat(child.dataset.knownSize);
    var size = itemSize(child, field);
    if (size === 0) {
      log("Zero-sized element, this should not happen", {
        child: child
      }, LogLevel.ERROR);
    }
    if (size === knownSize) {
      continue;
    }
    var lastResult = results[results.length - 1];
    if (results.length === 0 || lastResult.size !== size || lastResult.endIndex !== index - 1) {
      results.push({
        startIndex: index,
        endIndex: index,
        size: size
      });
    } else {
      results[results.length - 1].endIndex++;
    }
  }
  return results;
}
function resolveGapValue$1(property, value, log) {
  if (value !== "normal" && !(value == null ? void 0 : value.endsWith("px"))) {
    log("".concat(property, " was not resolved to pixel value correctly"), value, LogLevel.WARN);
  }
  if (value === "normal") {
    return 0;
  }
  return parseInt(value != null ? value : "0", 10);
}
function correctItemSize(el, dimension) {
  return Math.round(el.getBoundingClientRect()[dimension]);
}
function approximatelyEqual(num1, num2) {
  return Math.abs(num1 - num2) < 1.01;
}
function useScrollTop(scrollContainerStateCallback, smoothScrollTargetReached, scrollerElement) {
  var scrollerRefCallback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : noop;
  var customScrollParent = arguments.length > 4 ? arguments[4] : undefined;
  var scrollerRef = React.useRef(null);
  var scrollTopTarget = React.useRef(null);
  var timeoutRef = React.useRef(null);
  var handler = React.useCallback(function (ev) {
    var el = ev.target;
    var windowScroll = el === window || el === document;
    var scrollTop = windowScroll ? window.pageYOffset || document.documentElement.scrollTop : el.scrollTop;
    var scrollHeight = windowScroll ? document.documentElement.scrollHeight : el.scrollHeight;
    var viewportHeight = windowScroll ? window.innerHeight : el.offsetHeight;
    var call2 = function call2() {
      scrollContainerStateCallback({
        scrollTop: Math.max(scrollTop, 0),
        scrollHeight: scrollHeight,
        viewportHeight: viewportHeight
      });
    };
    if (ev.suppressFlushSync) {
      call2();
    } else {
      ReactDOM.flushSync(call2);
    }
    if (scrollTopTarget.current !== null) {
      if (scrollTop === scrollTopTarget.current || scrollTop <= 0 || scrollTop === scrollHeight - viewportHeight) {
        scrollTopTarget.current = null;
        smoothScrollTargetReached(true);
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
          timeoutRef.current = null;
        }
      }
    }
  }, [scrollContainerStateCallback, smoothScrollTargetReached]);
  React.useEffect(function () {
    var localRef = customScrollParent ? customScrollParent : scrollerRef.current;
    scrollerRefCallback(customScrollParent ? customScrollParent : scrollerRef.current);
    handler({
      target: localRef,
      suppressFlushSync: true
    });
    localRef.addEventListener("scroll", handler, {
      passive: true
    });
    return function () {
      scrollerRefCallback(null);
      localRef.removeEventListener("scroll", handler);
    };
  }, [scrollerRef, handler, scrollerElement, scrollerRefCallback, customScrollParent]);
  function scrollToCallback(location) {
    var scrollerElement2 = scrollerRef.current;
    if (!scrollerElement2 || "offsetHeight" in scrollerElement2 && scrollerElement2.offsetHeight === 0) {
      return;
    }
    var isSmooth = location.behavior === "smooth";
    var offsetHeight;
    var scrollHeight;
    var scrollTop;
    if (scrollerElement2 === window) {
      scrollHeight = Math.max(correctItemSize(document.documentElement, "height"), document.documentElement.scrollHeight);
      offsetHeight = window.innerHeight;
      scrollTop = document.documentElement.scrollTop;
    } else {
      scrollHeight = scrollerElement2.scrollHeight;
      offsetHeight = correctItemSize(scrollerElement2, "height");
      scrollTop = scrollerElement2.scrollTop;
    }
    var maxScrollTop = scrollHeight - offsetHeight;
    location.top = Math.ceil(Math.max(Math.min(maxScrollTop, location.top), 0));
    if (approximatelyEqual(offsetHeight, scrollHeight) || location.top === scrollTop) {
      scrollContainerStateCallback({
        scrollTop: scrollTop,
        scrollHeight: scrollHeight,
        viewportHeight: offsetHeight
      });
      if (isSmooth) {
        smoothScrollTargetReached(true);
      }
      return;
    }
    if (isSmooth) {
      scrollTopTarget.current = location.top;
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      timeoutRef.current = setTimeout(function () {
        timeoutRef.current = null;
        scrollTopTarget.current = null;
        smoothScrollTargetReached(true);
      }, 1e3);
    } else {
      scrollTopTarget.current = null;
    }
    scrollerElement2.scrollTo(location);
  }
  function scrollByCallback(location) {
    scrollerRef.current.scrollBy(location);
  }
  return {
    scrollerRef: scrollerRef,
    scrollByCallback: scrollByCallback,
    scrollToCallback: scrollToCallback
  };
}
var domIOSystem = system(function () {
  var scrollContainerState = stream();
  var scrollTop = stream();
  var deviation = statefulStream(0);
  var smoothScrollTargetReached = stream();
  var statefulScrollTop = statefulStream(0);
  var viewportHeight = stream();
  var scrollHeight = stream();
  var headerHeight = statefulStream(0);
  var fixedHeaderHeight = statefulStream(0);
  var fixedFooterHeight = statefulStream(0);
  var footerHeight = statefulStream(0);
  var scrollTo = stream();
  var scrollBy = stream();
  var scrollingInProgress = statefulStream(false);
  connect(pipe(scrollContainerState, map(function (_ref3) {
    var scrollTop2 = _ref3.scrollTop;
    return scrollTop2;
  })), scrollTop);
  connect(pipe(scrollContainerState, map(function (_ref4) {
    var scrollHeight2 = _ref4.scrollHeight;
    return scrollHeight2;
  })), scrollHeight);
  connect(scrollTop, statefulScrollTop);
  return {
    // input
    scrollContainerState: scrollContainerState,
    scrollTop: scrollTop,
    viewportHeight: viewportHeight,
    headerHeight: headerHeight,
    fixedHeaderHeight: fixedHeaderHeight,
    fixedFooterHeight: fixedFooterHeight,
    footerHeight: footerHeight,
    scrollHeight: scrollHeight,
    smoothScrollTargetReached: smoothScrollTargetReached,
    // signals
    scrollTo: scrollTo,
    scrollBy: scrollBy,
    // state
    statefulScrollTop: statefulScrollTop,
    deviation: deviation,
    scrollingInProgress: scrollingInProgress
  };
}, [], {
  singleton: true
});
var NIL_NODE = {
  lvl: 0
};
function newAANode(k, v, lvl) {
  var l = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : NIL_NODE;
  var r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : NIL_NODE;
  return {
    k: k,
    v: v,
    lvl: lvl,
    l: l,
    r: r
  };
}
function empty(node) {
  return node === NIL_NODE;
}
function newTree() {
  return NIL_NODE;
}
function remove(node, key) {
  if (empty(node)) return NIL_NODE;
  var k = node.k,
    l = node.l,
    r = node.r;
  if (key === k) {
    if (empty(l)) {
      return r;
    } else if (empty(r)) {
      return l;
    } else {
      var _last = last(l),
        _last2 = _slicedToArray(_last, 2),
        lastKey = _last2[0],
        lastValue = _last2[1];
      return adjust(clone(node, {
        k: lastKey,
        v: lastValue,
        l: deleteLast(l)
      }));
    }
  } else if (key < k) {
    return adjust(clone(node, {
      l: remove(l, key)
    }));
  } else {
    return adjust(clone(node, {
      r: remove(r, key)
    }));
  }
}
function find(node, key) {
  if (empty(node)) {
    return;
  }
  if (key === node.k) {
    return node.v;
  } else if (key < node.k) {
    return find(node.l, key);
  } else {
    return find(node.r, key);
  }
}
function findMaxKeyValue(node, value) {
  var field = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "k";
  if (empty(node)) {
    return [-Infinity, void 0];
  }
  if (Number(node[field]) === value) {
    return [node.k, node.v];
  }
  if (Number(node[field]) < value) {
    var r = findMaxKeyValue(node.r, value, field);
    if (r[0] === -Infinity) {
      return [node.k, node.v];
    } else {
      return r;
    }
  }
  return findMaxKeyValue(node.l, value, field);
}
function insert(node, k, v) {
  if (empty(node)) {
    return newAANode(k, v, 1);
  }
  if (k === node.k) {
    return clone(node, {
      k: k,
      v: v
    });
  } else if (k < node.k) {
    return rebalance(clone(node, {
      l: insert(node.l, k, v)
    }));
  } else {
    return rebalance(clone(node, {
      r: insert(node.r, k, v)
    }));
  }
}
function walkWithin(node, start, end) {
  if (empty(node)) {
    return [];
  }
  var k = node.k,
    v = node.v,
    l = node.l,
    r = node.r;
  var result = [];
  if (k > start) {
    result = result.concat(walkWithin(l, start, end));
  }
  if (k >= start && k <= end) {
    result.push({
      k: k,
      v: v
    });
  }
  if (k <= end) {
    result = result.concat(walkWithin(r, start, end));
  }
  return result;
}
function walk(node) {
  if (empty(node)) {
    return [];
  }
  return [].concat(_toConsumableArray(walk(node.l)), [{
    k: node.k,
    v: node.v
  }], _toConsumableArray(walk(node.r)));
}
function last(node) {
  return empty(node.r) ? [node.k, node.v] : last(node.r);
}
function deleteLast(node) {
  return empty(node.r) ? node.l : adjust(clone(node, {
    r: deleteLast(node.r)
  }));
}
function clone(node, args) {
  return newAANode(args.k !== void 0 ? args.k : node.k, args.v !== void 0 ? args.v : node.v, args.lvl !== void 0 ? args.lvl : node.lvl, args.l !== void 0 ? args.l : node.l, args.r !== void 0 ? args.r : node.r);
}
function isSingle(node) {
  return empty(node) || node.lvl > node.r.lvl;
}
function rebalance(node) {
  return split(skew(node));
}
function adjust(node) {
  var l = node.l,
    r = node.r,
    lvl = node.lvl;
  if (r.lvl >= lvl - 1 && l.lvl >= lvl - 1) {
    return node;
  } else if (lvl > r.lvl + 1) {
    if (isSingle(l)) {
      return skew(clone(node, {
        lvl: lvl - 1
      }));
    } else {
      if (!empty(l) && !empty(l.r)) {
        return clone(l.r, {
          l: clone(l, {
            r: l.r.l
          }),
          r: clone(node, {
            l: l.r.r,
            lvl: lvl - 1
          }),
          lvl: lvl
        });
      } else {
        throw new Error("Unexpected empty nodes");
      }
    }
  } else {
    if (isSingle(node)) {
      return split(clone(node, {
        lvl: lvl - 1
      }));
    } else {
      if (!empty(r) && !empty(r.l)) {
        var rl = r.l;
        var rlvl = isSingle(rl) ? r.lvl - 1 : r.lvl;
        return clone(rl, {
          l: clone(node, {
            r: rl.l,
            lvl: lvl - 1
          }),
          r: split(clone(r, {
            l: rl.r,
            lvl: rlvl
          })),
          lvl: rl.lvl + 1
        });
      } else {
        throw new Error("Unexpected empty nodes");
      }
    }
  }
}
function rangesWithin(node, startIndex, endIndex) {
  if (empty(node)) {
    return [];
  }
  var adjustedStart = findMaxKeyValue(node, startIndex)[0];
  return toRanges(walkWithin(node, adjustedStart, endIndex));
}
function arrayToRanges(items, parser) {
  var length = items.length;
  if (length === 0) {
    return [];
  }
  var _parser = parser(items[0]),
    start = _parser.index,
    value = _parser.value;
  var result = [];
  for (var i = 1; i < length; i++) {
    var _parser2 = parser(items[i]),
      nextIndex = _parser2.index,
      nextValue = _parser2.value;
    result.push({
      start: start,
      end: nextIndex - 1,
      value: value
    });
    start = nextIndex;
    value = nextValue;
  }
  result.push({
    start: start,
    end: Infinity,
    value: value
  });
  return result;
}
function toRanges(nodes) {
  return arrayToRanges(nodes, function (_ref5) {
    var index = _ref5.k,
      value = _ref5.v;
    return {
      index: index,
      value: value
    };
  });
}
function split(node) {
  var r = node.r,
    lvl = node.lvl;
  return !empty(r) && !empty(r.r) && r.lvl === lvl && r.r.lvl === lvl ? clone(r, {
    l: clone(node, {
      r: r.l
    }),
    lvl: lvl + 1
  }) : node;
}
function skew(node) {
  var l = node.l;
  return !empty(l) && l.lvl === node.lvl ? clone(l, {
    r: clone(node, {
      l: l.r
    })
  }) : node;
}
function findIndexOfClosestSmallerOrEqual(items, value, comparator) {
  var start = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var end = items.length - 1;
  while (start <= end) {
    var index = Math.floor((start + end) / 2);
    var item = items[index];
    var match = comparator(item, value);
    if (match === 0) {
      return index;
    }
    if (match === -1) {
      if (end - start < 2) {
        return index - 1;
      }
      end = index - 1;
    } else {
      if (end === start) {
        return index;
      }
      start = index + 1;
    }
  }
  throw new Error("Failed binary finding record in array - ".concat(items.join(","), ", searched for ").concat(value));
}
function findClosestSmallerOrEqual(items, value, comparator) {
  return items[findIndexOfClosestSmallerOrEqual(items, value, comparator)];
}
function findRange(items, startValue, endValue, comparator) {
  var startIndex = findIndexOfClosestSmallerOrEqual(items, startValue, comparator);
  var endIndex = findIndexOfClosestSmallerOrEqual(items, endValue, comparator, startIndex);
  return items.slice(startIndex, endIndex + 1);
}
var recalcSystem = system(function () {
  var recalcInProgress = statefulStream(false);
  return {
    recalcInProgress: recalcInProgress
  };
}, [], {
  singleton: true
});
function rangeIncludes(refRange) {
  var size = refRange.size,
    startIndex = refRange.startIndex,
    endIndex = refRange.endIndex;
  return function (range) {
    return range.start === startIndex && (range.end === endIndex || range.end === Infinity) && range.value === size;
  };
}
function affectedGroupCount(offset, groupIndices) {
  var recognizedOffsetItems = 0;
  var groupIndex = 0;
  while (recognizedOffsetItems < offset) {
    recognizedOffsetItems += groupIndices[groupIndex + 1] - groupIndices[groupIndex] - 1;
    groupIndex++;
  }
  var offsetIsExact = recognizedOffsetItems === offset;
  return groupIndex - (offsetIsExact ? 0 : 1);
}
function insertRanges(sizeTree, ranges) {
  var syncStart = empty(sizeTree) ? 0 : Infinity;
  var _iterator = _createForOfIteratorHelper(ranges),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var range = _step.value;
      var size = range.size,
        startIndex = range.startIndex,
        endIndex = range.endIndex;
      syncStart = Math.min(syncStart, startIndex);
      if (empty(sizeTree)) {
        sizeTree = insert(sizeTree, 0, size);
        continue;
      }
      var overlappingRanges = rangesWithin(sizeTree, startIndex - 1, endIndex + 1);
      if (overlappingRanges.some(rangeIncludes(range))) {
        continue;
      }
      var firstPassDone = false;
      var shouldInsert = false;
      var _iterator2 = _createForOfIteratorHelper(overlappingRanges),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _step2$value = _step2.value,
            rangeStart = _step2$value.start,
            rangeEnd = _step2$value.end,
            rangeValue = _step2$value.value;
          if (!firstPassDone) {
            shouldInsert = rangeValue !== size;
            firstPassDone = true;
          } else {
            if (endIndex >= rangeStart || size === rangeValue) {
              sizeTree = remove(sizeTree, rangeStart);
            }
          }
          if (rangeEnd > endIndex && endIndex >= rangeStart) {
            if (rangeValue !== size) {
              sizeTree = insert(sizeTree, endIndex + 1, rangeValue);
            }
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      if (shouldInsert) {
        sizeTree = insert(sizeTree, startIndex, size);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return [sizeTree, syncStart];
}
function initialSizeState() {
  return {
    offsetTree: [],
    sizeTree: newTree(),
    groupOffsetTree: newTree(),
    lastIndex: 0,
    lastOffset: 0,
    lastSize: 0,
    groupIndices: []
  };
}
function indexComparator(_ref6, index) {
  var itemIndex = _ref6.index;
  return index === itemIndex ? 0 : index < itemIndex ? -1 : 1;
}
function offsetComparator(_ref7, offset) {
  var itemOffset = _ref7.offset;
  return offset === itemOffset ? 0 : offset < itemOffset ? -1 : 1;
}
function offsetPointParser(point) {
  return {
    index: point.index,
    value: point
  };
}
function rangesWithinOffsets(tree, startOffset, endOffset) {
  var minStartIndex = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  if (minStartIndex > 0) {
    startOffset = Math.max(startOffset, findClosestSmallerOrEqual(tree, minStartIndex, indexComparator).offset);
  }
  return arrayToRanges(findRange(tree, startOffset, endOffset, offsetComparator), offsetPointParser);
}
function createOffsetTree(prevOffsetTree, syncStart, sizeTree, gap) {
  var offsetTree = prevOffsetTree;
  var prevIndex = 0;
  var prevSize = 0;
  var prevOffset = 0;
  var startIndex = 0;
  if (syncStart !== 0) {
    startIndex = findIndexOfClosestSmallerOrEqual(offsetTree, syncStart - 1, indexComparator);
    var offsetInfo = offsetTree[startIndex];
    prevOffset = offsetInfo.offset;
    var kv = findMaxKeyValue(sizeTree, syncStart - 1);
    prevIndex = kv[0];
    prevSize = kv[1];
    if (offsetTree.length && offsetTree[startIndex].size === findMaxKeyValue(sizeTree, syncStart)[1]) {
      startIndex -= 1;
    }
    offsetTree = offsetTree.slice(0, startIndex + 1);
  } else {
    offsetTree = [];
  }
  var _iterator3 = _createForOfIteratorHelper(rangesWithin(sizeTree, syncStart, Infinity)),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var _step3$value = _step3.value,
        startIndex2 = _step3$value.start,
        value = _step3$value.value;
      var indexOffset = startIndex2 - prevIndex;
      var aOffset = indexOffset * prevSize + prevOffset + indexOffset * gap;
      offsetTree.push({
        offset: aOffset,
        size: value,
        index: startIndex2
      });
      prevIndex = startIndex2;
      prevOffset = aOffset;
      prevSize = value;
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  return {
    offsetTree: offsetTree,
    lastIndex: prevIndex,
    lastOffset: prevOffset,
    lastSize: prevSize
  };
}
function sizeStateReducer(state, _ref8) {
  var _ref9 = _slicedToArray(_ref8, 4),
    ranges = _ref9[0],
    groupIndices = _ref9[1],
    log = _ref9[2],
    gap = _ref9[3];
  if (ranges.length > 0) {
    log("received item sizes", ranges, LogLevel.DEBUG);
  }
  var sizeTree = state.sizeTree;
  var newSizeTree = sizeTree;
  var syncStart = 0;
  if (groupIndices.length > 0 && empty(sizeTree) && ranges.length === 2) {
    var groupSize = ranges[0].size;
    var itemSize = ranges[1].size;
    newSizeTree = groupIndices.reduce(function (tree, groupIndex) {
      return insert(insert(tree, groupIndex, groupSize), groupIndex + 1, itemSize);
    }, newSizeTree);
  } else {
    var _insertRanges = insertRanges(newSizeTree, ranges);
    var _insertRanges2 = _slicedToArray(_insertRanges, 2);
    newSizeTree = _insertRanges2[0];
    syncStart = _insertRanges2[1];
  }
  if (newSizeTree === sizeTree) {
    return state;
  }
  var _createOffsetTree = createOffsetTree(state.offsetTree, syncStart, newSizeTree, gap),
    newOffsetTree = _createOffsetTree.offsetTree,
    lastIndex = _createOffsetTree.lastIndex,
    lastSize = _createOffsetTree.lastSize,
    lastOffset = _createOffsetTree.lastOffset;
  return {
    sizeTree: newSizeTree,
    offsetTree: newOffsetTree,
    lastIndex: lastIndex,
    lastOffset: lastOffset,
    lastSize: lastSize,
    groupOffsetTree: groupIndices.reduce(function (tree, index) {
      return insert(tree, index, offsetOf(index, newOffsetTree, gap));
    }, newTree()),
    groupIndices: groupIndices
  };
}
function offsetOf(index, tree, gap) {
  if (tree.length === 0) {
    return 0;
  }
  var _findClosestSmallerOr = findClosestSmallerOrEqual(tree, index, indexComparator),
    offset = _findClosestSmallerOr.offset,
    startIndex = _findClosestSmallerOr.index,
    size = _findClosestSmallerOr.size;
  var itemCount = index - startIndex;
  var top = size * itemCount + (itemCount - 1) * gap + offset;
  return top > 0 ? top + gap : top;
}
function isGroupLocation(location) {
  return typeof location.groupIndex !== "undefined";
}
function originalIndexFromLocation(location, sizes, lastIndex) {
  if (isGroupLocation(location)) {
    return sizes.groupIndices[location.groupIndex] + 1;
  } else {
    var numericIndex = location.index === "LAST" ? lastIndex : location.index;
    var result = originalIndexFromItemIndex(numericIndex, sizes);
    result = Math.max(0, result, Math.min(lastIndex, result));
    return result;
  }
}
function originalIndexFromItemIndex(itemIndex, sizes) {
  if (!hasGroups(sizes)) {
    return itemIndex;
  }
  var groupOffset = 0;
  while (sizes.groupIndices[groupOffset] <= itemIndex + groupOffset) {
    groupOffset++;
  }
  return itemIndex + groupOffset;
}
function hasGroups(sizes) {
  return !empty(sizes.groupOffsetTree);
}
function sizeTreeToRanges(sizeTree) {
  return walk(sizeTree).map(function (_ref10, index, sizeArray) {
    var startIndex = _ref10.k,
      size = _ref10.v;
    var nextSize = sizeArray[index + 1];
    var endIndex = nextSize ? nextSize.k - 1 : Infinity;
    return {
      startIndex: startIndex,
      endIndex: endIndex,
      size: size
    };
  });
}
var SIZE_MAP = {
  offsetHeight: "height",
  offsetWidth: "width"
};
var sizeSystem = system(function (_ref11) {
  var _ref12 = _slicedToArray(_ref11, 2),
    log = _ref12[0].log,
    recalcInProgress = _ref12[1].recalcInProgress;
  var sizeRanges = stream();
  var totalCount = stream();
  var statefulTotalCount = statefulStreamFromEmitter(totalCount, 0);
  var unshiftWith = stream();
  var shiftWith = stream();
  var firstItemIndex = statefulStream(0);
  var groupIndices = statefulStream([]);
  var fixedItemSize = statefulStream(void 0);
  var defaultItemSize = statefulStream(void 0);
  var itemSize = statefulStream(function (el, field) {
    return correctItemSize(el, SIZE_MAP[field]);
  });
  var data = statefulStream(void 0);
  var gap = statefulStream(0);
  var initial = initialSizeState();
  var sizes = statefulStreamFromEmitter(pipe(sizeRanges, withLatestFrom(groupIndices, log, gap), scan(sizeStateReducer, initial), distinctUntilChanged()), initial);
  var prevGroupIndices = statefulStreamFromEmitter(pipe(groupIndices, distinctUntilChanged(), scan(function (prev, curr) {
    return {
      prev: prev.current,
      current: curr
    };
  }, {
    prev: [],
    current: []
  }), map(function (_ref13) {
    var prev = _ref13.prev;
    return prev;
  })), []);
  connect(pipe(groupIndices, filter(function (indexes) {
    return indexes.length > 0;
  }), withLatestFrom(sizes, gap), map(function (_ref14) {
    var _ref15 = _slicedToArray(_ref14, 3),
      groupIndices2 = _ref15[0],
      sizes2 = _ref15[1],
      gap2 = _ref15[2];
    var groupOffsetTree = groupIndices2.reduce(function (tree, index, idx) {
      return insert(tree, index, offsetOf(index, sizes2.offsetTree, gap2) || idx);
    }, newTree());
    return _objectSpread(_objectSpread({}, sizes2), {}, {
      groupIndices: groupIndices2,
      groupOffsetTree: groupOffsetTree
    });
  })), sizes);
  connect(pipe(totalCount, withLatestFrom(sizes), filter(function (_ref16) {
    var _ref17 = _slicedToArray(_ref16, 2),
      totalCount2 = _ref17[0],
      lastIndex = _ref17[1].lastIndex;
    return totalCount2 < lastIndex;
  }), map(function (_ref18) {
    var _ref19 = _slicedToArray(_ref18, 2),
      totalCount2 = _ref19[0],
      _ref19$ = _ref19[1],
      lastIndex = _ref19$.lastIndex,
      lastSize = _ref19$.lastSize;
    return [{
      startIndex: totalCount2,
      endIndex: lastIndex,
      size: lastSize
    }];
  })), sizeRanges);
  connect(fixedItemSize, defaultItemSize);
  var trackItemSizes = statefulStreamFromEmitter(pipe(fixedItemSize, map(function (size) {
    return size === void 0;
  })), true);
  connect(pipe(defaultItemSize, filter(function (value) {
    return value !== void 0 && empty(getValue(sizes).sizeTree);
  }), map(function (size) {
    return [{
      startIndex: 0,
      endIndex: 0,
      size: size
    }];
  })), sizeRanges);
  var listRefresh = streamFromEmitter(pipe(sizeRanges, withLatestFrom(sizes), scan(function (_ref20, _ref21) {
    var oldSizes = _ref20.sizes;
    var _ref22 = _slicedToArray(_ref21, 2),
      _ = _ref22[0],
      newSizes = _ref22[1];
    return {
      changed: newSizes !== oldSizes,
      sizes: newSizes
    };
  }, {
    changed: false,
    sizes: initial
  }), map(function (value) {
    return value.changed;
  })));
  subscribe(pipe(firstItemIndex, scan(function (prev, next) {
    return {
      diff: prev.prev - next,
      prev: next
    };
  }, {
    diff: 0,
    prev: 0
  }), map(function (val) {
    return val.diff;
  })), function (offset) {
    var _getValue = getValue(sizes),
      groupIndices2 = _getValue.groupIndices;
    if (offset > 0) {
      publish(recalcInProgress, true);
      publish(unshiftWith, offset + affectedGroupCount(offset, groupIndices2));
    } else if (offset < 0) {
      var prevGroupIndicesValue = getValue(prevGroupIndices);
      if (prevGroupIndicesValue.length > 0) {
        offset -= affectedGroupCount(-offset, prevGroupIndicesValue);
      }
      publish(shiftWith, offset);
    }
  });
  subscribe(pipe(firstItemIndex, withLatestFrom(log)), function (_ref23) {
    var _ref24 = _slicedToArray(_ref23, 2),
      index = _ref24[0],
      log2 = _ref24[1];
    if (index < 0) {
      log2("`firstItemIndex` prop should not be set to less than zero. If you don't know the total count, just use a very high value", {
        firstItemIndex: firstItemIndex
      }, LogLevel.ERROR);
    }
  });
  var beforeUnshiftWith = streamFromEmitter(unshiftWith);
  connect(pipe(unshiftWith, withLatestFrom(sizes), map(function (_ref25) {
    var _ref26 = _slicedToArray(_ref25, 2),
      unshiftWith2 = _ref26[0],
      sizes2 = _ref26[1];
    var groupedMode = sizes2.groupIndices.length > 0;
    var initialRanges = [];
    var defaultSize = sizes2.lastSize;
    if (groupedMode) {
      var firstGroupSize = find(sizes2.sizeTree, 0);
      var prependedGroupItemsCount = 0;
      var groupIndex = 0;
      while (prependedGroupItemsCount < unshiftWith2) {
        var theGroupIndex = sizes2.groupIndices[groupIndex];
        var groupItemCount = sizes2.groupIndices.length === groupIndex + 1 ? Infinity : sizes2.groupIndices[groupIndex + 1] - theGroupIndex - 1;
        initialRanges.push({
          startIndex: theGroupIndex,
          endIndex: theGroupIndex,
          size: firstGroupSize
        });
        initialRanges.push({
          startIndex: theGroupIndex + 1,
          endIndex: theGroupIndex + 1 + groupItemCount - 1,
          size: defaultSize
        });
        groupIndex++;
        prependedGroupItemsCount += groupItemCount + 1;
      }
      var sizeTreeKV = walk(sizes2.sizeTree);
      var firstGroupIsExpanded = prependedGroupItemsCount !== unshiftWith2;
      if (firstGroupIsExpanded) {
        sizeTreeKV.shift();
      }
      return sizeTreeKV.reduce(function (acc, _ref27) {
        var index = _ref27.k,
          size = _ref27.v;
        var ranges = acc.ranges;
        if (acc.prevSize !== 0) {
          ranges = [].concat(_toConsumableArray(acc.ranges), [{
            startIndex: acc.prevIndex,
            endIndex: index + unshiftWith2 - 1,
            size: acc.prevSize
          }]);
        }
        return {
          ranges: ranges,
          prevIndex: index + unshiftWith2,
          prevSize: size
        };
      }, {
        ranges: initialRanges,
        prevIndex: unshiftWith2,
        prevSize: 0
      }).ranges;
    }
    return walk(sizes2.sizeTree).reduce(function (acc, _ref28) {
      var index = _ref28.k,
        size = _ref28.v;
      return {
        ranges: [].concat(_toConsumableArray(acc.ranges), [{
          startIndex: acc.prevIndex,
          endIndex: index + unshiftWith2 - 1,
          size: acc.prevSize
        }]),
        prevIndex: index + unshiftWith2,
        prevSize: size
      };
    }, {
      ranges: [],
      prevIndex: 0,
      prevSize: defaultSize
    }).ranges;
  })), sizeRanges);
  var shiftWithOffset = streamFromEmitter(pipe(shiftWith, withLatestFrom(sizes, gap), map(function (_ref29) {
    var _ref30 = _slicedToArray(_ref29, 3),
      shiftWith2 = _ref30[0],
      offsetTree = _ref30[1].offsetTree,
      gap2 = _ref30[2];
    var newFirstItemIndex = -shiftWith2;
    return offsetOf(newFirstItemIndex, offsetTree, gap2);
  })));
  connect(pipe(shiftWith, withLatestFrom(sizes, gap), map(function (_ref31) {
    var _ref32 = _slicedToArray(_ref31, 3),
      shiftWith2 = _ref32[0],
      sizes2 = _ref32[1],
      gap2 = _ref32[2];
    var groupedMode = sizes2.groupIndices.length > 0;
    if (groupedMode) {
      if (empty(sizes2.sizeTree)) {
        return sizes2;
      }
      var newSizeTree = newTree();
      var prevGroupIndicesValue = getValue(prevGroupIndices);
      var removedItemsCount = 0;
      var groupIndex = 0;
      var groupOffset = 0;
      while (removedItemsCount < -shiftWith2) {
        groupOffset = prevGroupIndicesValue[groupIndex];
        var groupItemCount = prevGroupIndicesValue[groupIndex + 1] - groupOffset - 1;
        groupIndex++;
        removedItemsCount += groupItemCount + 1;
      }
      newSizeTree = walk(sizes2.sizeTree).reduce(function (acc, _ref33) {
        var k = _ref33.k,
          v = _ref33.v;
        return insert(acc, Math.max(0, k + shiftWith2), v);
      }, newSizeTree);
      var aGroupIsShrunk = removedItemsCount !== -shiftWith2;
      if (aGroupIsShrunk) {
        var firstGroupSize = find(sizes2.sizeTree, groupOffset);
        newSizeTree = insert(newSizeTree, 0, firstGroupSize);
        var nextItemSize = findMaxKeyValue(sizes2.sizeTree, -shiftWith2 + 1)[1];
        newSizeTree = insert(newSizeTree, 1, nextItemSize);
      }
      return _objectSpread(_objectSpread({}, sizes2), {}, {
        sizeTree: newSizeTree
      }, createOffsetTree(sizes2.offsetTree, 0, newSizeTree, gap2));
    } else {
      var _newSizeTree = walk(sizes2.sizeTree).reduce(function (acc, _ref34) {
        var k = _ref34.k,
          v = _ref34.v;
        return insert(acc, Math.max(0, k + shiftWith2), v);
      }, newTree());
      return _objectSpread(_objectSpread({}, sizes2), {}, {
        sizeTree: _newSizeTree
      }, createOffsetTree(sizes2.offsetTree, 0, _newSizeTree, gap2));
    }
  })), sizes);
  return {
    // input
    data: data,
    totalCount: totalCount,
    sizeRanges: sizeRanges,
    groupIndices: groupIndices,
    defaultItemSize: defaultItemSize,
    fixedItemSize: fixedItemSize,
    unshiftWith: unshiftWith,
    shiftWith: shiftWith,
    shiftWithOffset: shiftWithOffset,
    beforeUnshiftWith: beforeUnshiftWith,
    firstItemIndex: firstItemIndex,
    gap: gap,
    // output
    sizes: sizes,
    listRefresh: listRefresh,
    statefulTotalCount: statefulTotalCount,
    trackItemSizes: trackItemSizes,
    itemSize: itemSize
  };
}, tup(loggerSystem, recalcSystem), {
  singleton: true
});
var SUPPORTS_SCROLL_TO_OPTIONS = typeof document !== "undefined" && "scrollBehavior" in document.documentElement.style;
function normalizeIndexLocation(location) {
  var result = typeof location === "number" ? {
    index: location
  } : location;
  if (!result.align) {
    result.align = "start";
  }
  if (!result.behavior || !SUPPORTS_SCROLL_TO_OPTIONS) {
    result.behavior = "auto";
  }
  if (!result.offset) {
    result.offset = 0;
  }
  return result;
}
var scrollToIndexSystem = system(function (_ref35) {
  var _ref36 = _slicedToArray(_ref35, 3),
    _ref36$ = _ref36[0],
    sizes = _ref36$.sizes,
    totalCount = _ref36$.totalCount,
    listRefresh = _ref36$.listRefresh,
    gap = _ref36$.gap,
    _ref36$2 = _ref36[1],
    scrollingInProgress = _ref36$2.scrollingInProgress,
    viewportHeight = _ref36$2.viewportHeight,
    scrollTo = _ref36$2.scrollTo,
    smoothScrollTargetReached = _ref36$2.smoothScrollTargetReached,
    headerHeight = _ref36$2.headerHeight,
    footerHeight = _ref36$2.footerHeight,
    fixedHeaderHeight = _ref36$2.fixedHeaderHeight,
    fixedFooterHeight = _ref36$2.fixedFooterHeight,
    log = _ref36[2].log;
  var scrollToIndex = stream();
  var topListHeight = statefulStream(0);
  var unsubscribeNextListRefresh = null;
  var cleartTimeoutRef = null;
  var unsubscribeListRefresh = null;
  function cleanup() {
    if (unsubscribeNextListRefresh) {
      unsubscribeNextListRefresh();
      unsubscribeNextListRefresh = null;
    }
    if (unsubscribeListRefresh) {
      unsubscribeListRefresh();
      unsubscribeListRefresh = null;
    }
    if (cleartTimeoutRef) {
      clearTimeout(cleartTimeoutRef);
      cleartTimeoutRef = null;
    }
    publish(scrollingInProgress, false);
  }
  connect(pipe(scrollToIndex, withLatestFrom(sizes, viewportHeight, totalCount, topListHeight, headerHeight, footerHeight, log), withLatestFrom(gap, fixedHeaderHeight, fixedFooterHeight), map(function (_ref37) {
    var _ref38 = _slicedToArray(_ref37, 4),
      _ref38$ = _slicedToArray(_ref38[0], 8),
      location = _ref38$[0],
      sizes2 = _ref38$[1],
      viewportHeight2 = _ref38$[2],
      totalCount2 = _ref38$[3],
      topListHeight2 = _ref38$[4],
      headerHeight2 = _ref38$[5],
      footerHeight2 = _ref38$[6],
      log2 = _ref38$[7],
      gap2 = _ref38[1],
      fixedHeaderHeight2 = _ref38[2],
      fixedFooterHeight2 = _ref38[3];
    var normalLocation = normalizeIndexLocation(location);
    var align = normalLocation.align,
      behavior = normalLocation.behavior,
      offset = normalLocation.offset;
    var lastIndex = totalCount2 - 1;
    var index = originalIndexFromLocation(normalLocation, sizes2, lastIndex);
    var top = offsetOf(index, sizes2.offsetTree, gap2) + headerHeight2;
    if (align === "end") {
      top += fixedHeaderHeight2 + findMaxKeyValue(sizes2.sizeTree, index)[1] - viewportHeight2 + fixedFooterHeight2;
      if (index === lastIndex) {
        top += footerHeight2;
      }
    } else if (align === "center") {
      top += (fixedHeaderHeight2 + findMaxKeyValue(sizes2.sizeTree, index)[1] - viewportHeight2 + fixedFooterHeight2) / 2;
    } else {
      top -= topListHeight2;
    }
    if (offset) {
      top += offset;
    }
    var retry = function retry(listChanged) {
      cleanup();
      if (listChanged) {
        log2("retrying to scroll to", {
          location: location
        }, LogLevel.DEBUG);
        publish(scrollToIndex, location);
      } else {
        log2("list did not change, scroll successful", {}, LogLevel.DEBUG);
      }
    };
    cleanup();
    if (behavior === "smooth") {
      var listChanged = false;
      unsubscribeListRefresh = subscribe(listRefresh, function (changed) {
        listChanged = listChanged || changed;
      });
      unsubscribeNextListRefresh = handleNext(smoothScrollTargetReached, function () {
        retry(listChanged);
      });
    } else {
      unsubscribeNextListRefresh = handleNext(pipe(listRefresh, watchChangesFor(150)), retry);
    }
    cleartTimeoutRef = setTimeout(function () {
      cleanup();
    }, 1200);
    publish(scrollingInProgress, true);
    log2("scrolling from index to", {
      index: index,
      top: top,
      behavior: behavior
    }, LogLevel.DEBUG);
    return {
      top: top,
      behavior: behavior
    };
  })), scrollTo);
  return {
    scrollToIndex: scrollToIndex,
    topListHeight: topListHeight
  };
}, tup(sizeSystem, domIOSystem, loggerSystem), {
  singleton: true
});
function watchChangesFor(limit) {
  return function (done) {
    var timeoutRef = setTimeout(function () {
      done(false);
    }, limit);
    return function (value) {
      if (value) {
        done(true);
        clearTimeout(timeoutRef);
      }
    };
  };
}
var UP = "up";
var DOWN = "down";
var NONE$1 = "none";
var INITIAL_BOTTOM_STATE = {
  atBottom: false,
  notAtBottomBecause: "NOT_SHOWING_LAST_ITEM",
  state: {
    offsetBottom: 0,
    scrollTop: 0,
    viewportHeight: 0,
    scrollHeight: 0
  }
};
var DEFAULT_AT_TOP_THRESHOLD = 0;
var stateFlagsSystem = system(function (_ref39) {
  var _ref40 = _slicedToArray(_ref39, 1),
    _ref40$ = _ref40[0],
    scrollContainerState = _ref40$.scrollContainerState,
    scrollTop = _ref40$.scrollTop,
    viewportHeight = _ref40$.viewportHeight,
    headerHeight = _ref40$.headerHeight,
    footerHeight = _ref40$.footerHeight,
    scrollBy = _ref40$.scrollBy;
  var isAtBottom = statefulStream(false);
  var isAtTop = statefulStream(true);
  var atBottomStateChange = stream();
  var atTopStateChange = stream();
  var atBottomThreshold = statefulStream(4);
  var atTopThreshold = statefulStream(DEFAULT_AT_TOP_THRESHOLD);
  var isScrolling = statefulStreamFromEmitter(pipe(merge(pipe(duc(scrollTop), skip(1), mapTo(true)), pipe(duc(scrollTop), skip(1), mapTo(false), debounceTime(100))), distinctUntilChanged()), false);
  var isScrollingBy = statefulStreamFromEmitter(pipe(merge(pipe(scrollBy, mapTo(true)), pipe(scrollBy, mapTo(false), debounceTime(200))), distinctUntilChanged()), false);
  connect(pipe(combineLatest(duc(scrollTop), duc(atTopThreshold)), map(function (_ref41) {
    var _ref42 = _slicedToArray(_ref41, 2),
      top = _ref42[0],
      atTopThreshold2 = _ref42[1];
    return top <= atTopThreshold2;
  }), distinctUntilChanged()), isAtTop);
  connect(pipe(isAtTop, throttleTime(50)), atTopStateChange);
  var atBottomState = streamFromEmitter(pipe(combineLatest(scrollContainerState, duc(viewportHeight), duc(headerHeight), duc(footerHeight), duc(atBottomThreshold)), scan(function (current, _ref43) {
    var _ref44 = _slicedToArray(_ref43, 5),
      _ref44$ = _ref44[0],
      scrollTop2 = _ref44$.scrollTop,
      scrollHeight = _ref44$.scrollHeight,
      viewportHeight2 = _ref44[1],
      _headerHeight = _ref44[2],
      _footerHeight = _ref44[3],
      atBottomThreshold2 = _ref44[4];
    var isAtBottom2 = scrollTop2 + viewportHeight2 - scrollHeight > -atBottomThreshold2;
    var state = {
      viewportHeight: viewportHeight2,
      scrollTop: scrollTop2,
      scrollHeight: scrollHeight
    };
    if (isAtBottom2) {
      var atBottomBecause;
      var scrollTopDelta;
      if (scrollTop2 > current.state.scrollTop) {
        atBottomBecause = "SCROLLED_DOWN";
        scrollTopDelta = current.state.scrollTop - scrollTop2;
      } else {
        atBottomBecause = "SIZE_DECREASED";
        scrollTopDelta = current.state.scrollTop - scrollTop2 || current.scrollTopDelta;
      }
      return {
        atBottom: true,
        state: state,
        atBottomBecause: atBottomBecause,
        scrollTopDelta: scrollTopDelta
      };
    }
    var notAtBottomBecause;
    if (state.scrollHeight > current.state.scrollHeight) {
      notAtBottomBecause = "SIZE_INCREASED";
    } else if (viewportHeight2 < current.state.viewportHeight) {
      notAtBottomBecause = "VIEWPORT_HEIGHT_DECREASING";
    } else if (scrollTop2 < current.state.scrollTop) {
      notAtBottomBecause = "SCROLLING_UPWARDS";
    } else {
      notAtBottomBecause = "NOT_FULLY_SCROLLED_TO_LAST_ITEM_BOTTOM";
    }
    return {
      atBottom: false,
      notAtBottomBecause: notAtBottomBecause,
      state: state
    };
  }, INITIAL_BOTTOM_STATE), distinctUntilChanged(function (prev, next) {
    return prev && prev.atBottom === next.atBottom;
  })));
  var lastJumpDueToItemResize = statefulStreamFromEmitter(pipe(scrollContainerState, scan(function (current, _ref45) {
    var scrollTop2 = _ref45.scrollTop,
      scrollHeight = _ref45.scrollHeight,
      viewportHeight2 = _ref45.viewportHeight;
    if (!approximatelyEqual(current.scrollHeight, scrollHeight)) {
      var atBottom = scrollHeight - (scrollTop2 + viewportHeight2) < 1;
      if (current.scrollTop !== scrollTop2 && atBottom) {
        return {
          scrollHeight: scrollHeight,
          scrollTop: scrollTop2,
          jump: current.scrollTop - scrollTop2,
          changed: true
        };
      } else {
        return {
          scrollHeight: scrollHeight,
          scrollTop: scrollTop2,
          jump: 0,
          changed: true
        };
      }
    } else {
      return {
        scrollTop: scrollTop2,
        scrollHeight: scrollHeight,
        jump: 0,
        changed: false
      };
    }
  }, {
    scrollHeight: 0,
    jump: 0,
    scrollTop: 0,
    changed: false
  }), filter(function (value) {
    return value.changed;
  }), map(function (value) {
    return value.jump;
  })), 0);
  connect(pipe(atBottomState, map(function (state) {
    return state.atBottom;
  })), isAtBottom);
  connect(pipe(isAtBottom, throttleTime(50)), atBottomStateChange);
  var scrollDirection = statefulStream(DOWN);
  connect(pipe(scrollContainerState, map(function (_ref46) {
    var scrollTop2 = _ref46.scrollTop;
    return scrollTop2;
  }), distinctUntilChanged(), scan(function (acc, scrollTop2) {
    if (getValue(isScrollingBy)) {
      return {
        direction: acc.direction,
        prevScrollTop: scrollTop2
      };
    }
    return {
      direction: scrollTop2 < acc.prevScrollTop ? UP : DOWN,
      prevScrollTop: scrollTop2
    };
  }, {
    direction: DOWN,
    prevScrollTop: 0
  }), map(function (value) {
    return value.direction;
  })), scrollDirection);
  connect(pipe(scrollContainerState, throttleTime(50), mapTo(NONE$1)), scrollDirection);
  var scrollVelocity = statefulStream(0);
  connect(pipe(isScrolling, filter(function (value) {
    return !value;
  }),
  // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
  mapTo(0)), scrollVelocity);
  connect(pipe(scrollTop, throttleTime(100), withLatestFrom(isScrolling), filter(function (_ref47) {
    var _ref48 = _slicedToArray(_ref47, 2),
      _ = _ref48[0],
      isScrolling2 = _ref48[1];
    return !!isScrolling2;
  }), scan(function (_ref49, _ref50) {
    var _ref51 = _slicedToArray(_ref49, 2),
      _ = _ref51[0],
      prev = _ref51[1];
    var _ref52 = _slicedToArray(_ref50, 1),
      next = _ref52[0];
    return [prev, next];
  }, [0, 0]), map(function (_ref53) {
    var _ref54 = _slicedToArray(_ref53, 2),
      prev = _ref54[0],
      next = _ref54[1];
    return next - prev;
  })), scrollVelocity);
  return {
    isScrolling: isScrolling,
    isAtTop: isAtTop,
    isAtBottom: isAtBottom,
    atBottomState: atBottomState,
    atTopStateChange: atTopStateChange,
    atBottomStateChange: atBottomStateChange,
    scrollDirection: scrollDirection,
    atBottomThreshold: atBottomThreshold,
    atTopThreshold: atTopThreshold,
    scrollVelocity: scrollVelocity,
    lastJumpDueToItemResize: lastJumpDueToItemResize
  };
}, tup(domIOSystem));
var propsReadySystem = system(function (_ref55) {
  var _ref56 = _slicedToArray(_ref55, 1),
    log = _ref56[0].log;
  var propsReady = statefulStream(false);
  var didMount = streamFromEmitter(pipe(propsReady, filter(function (ready) {
    return ready;
  }), distinctUntilChanged()));
  subscribe(propsReady, function (value) {
    value && getValue(log)("props updated", {}, LogLevel.DEBUG);
  });
  return {
    propsReady: propsReady,
    didMount: didMount
  };
}, tup(loggerSystem), {
  singleton: true
});
function skipFrames(frameCount, callback) {
  if (frameCount == 0) {
    callback();
  } else {
    requestAnimationFrame(function () {
      return skipFrames(frameCount - 1, callback);
    });
  }
}
function getInitialTopMostItemIndexNumber(location, totalCount) {
  var lastIndex = totalCount - 1;
  var index = typeof location === "number" ? location : location.index === "LAST" ? lastIndex : location.index;
  return index;
}
var initialTopMostItemIndexSystem = system(function (_ref57) {
  var _ref58 = _slicedToArray(_ref57, 4),
    _ref58$ = _ref58[0],
    sizes = _ref58$.sizes,
    listRefresh = _ref58$.listRefresh,
    defaultItemSize = _ref58$.defaultItemSize,
    scrollTop = _ref58[1].scrollTop,
    scrollToIndex = _ref58[2].scrollToIndex,
    didMount = _ref58[3].didMount;
  var scrolledToInitialItem = statefulStream(true);
  var initialTopMostItemIndex = statefulStream(0);
  var scrollScheduled = statefulStream(false);
  connect(pipe(didMount, withLatestFrom(initialTopMostItemIndex), filter(function (_ref59) {
    var _ref60 = _slicedToArray(_ref59, 2),
      _ = _ref60[0],
      location = _ref60[1];
    return !!location;
  }), mapTo(false)), scrolledToInitialItem);
  subscribe(pipe(combineLatest(listRefresh, didMount), withLatestFrom(scrolledToInitialItem, sizes, defaultItemSize, scrollScheduled), filter(function (_ref61) {
    var _ref62 = _slicedToArray(_ref61, 5),
      _ref62$ = _slicedToArray(_ref62[0], 2),
      didMount2 = _ref62$[1],
      scrolledToInitialItem2 = _ref62[1],
      sizeTree = _ref62[2].sizeTree,
      defaultItemSize2 = _ref62[3],
      scrollScheduled2 = _ref62[4];
    return didMount2 && (!empty(sizeTree) || isDefined(defaultItemSize2)) && !scrolledToInitialItem2 && !scrollScheduled2;
  }), withLatestFrom(initialTopMostItemIndex)), function (_ref63) {
    var _ref64 = _slicedToArray(_ref63, 2),
      initialTopMostItemIndex2 = _ref64[1];
    publish(scrollScheduled, true);
    skipFrames(3, function () {
      handleNext(scrollTop, function () {
        return publish(scrolledToInitialItem, true);
      });
      publish(scrollToIndex, initialTopMostItemIndex2);
    });
  });
  return {
    scrolledToInitialItem: scrolledToInitialItem,
    initialTopMostItemIndex: initialTopMostItemIndex
  };
}, tup(sizeSystem, domIOSystem, scrollToIndexSystem, propsReadySystem), {
  singleton: true
});
function normalizeFollowOutput(follow) {
  if (!follow) {
    return false;
  }
  return follow === "smooth" ? "smooth" : "auto";
}
var behaviorFromFollowOutput = function behaviorFromFollowOutput(follow, isAtBottom) {
  if (typeof follow === "function") {
    return normalizeFollowOutput(follow(isAtBottom));
  }
  return isAtBottom && normalizeFollowOutput(follow);
};
var followOutputSystem = system(function (_ref65) {
  var _ref66 = _slicedToArray(_ref65, 7),
    _ref66$ = _ref66[0],
    totalCount = _ref66$.totalCount,
    listRefresh = _ref66$.listRefresh,
    _ref66$2 = _ref66[1],
    isAtBottom = _ref66$2.isAtBottom,
    atBottomState = _ref66$2.atBottomState,
    scrollToIndex = _ref66[2].scrollToIndex,
    scrolledToInitialItem = _ref66[3].scrolledToInitialItem,
    _ref66$3 = _ref66[4],
    propsReady = _ref66$3.propsReady,
    didMount = _ref66$3.didMount,
    log = _ref66[5].log,
    scrollingInProgress = _ref66[6].scrollingInProgress;
  var followOutput = statefulStream(false);
  var autoscrollToBottom = stream();
  var pendingScrollHandle = null;
  function scrollToBottom(followOutputBehavior) {
    publish(scrollToIndex, {
      index: "LAST",
      align: "end",
      behavior: followOutputBehavior
    });
  }
  subscribe(pipe(combineLatest(pipe(duc(totalCount), skip(1)), didMount), withLatestFrom(duc(followOutput), isAtBottom, scrolledToInitialItem, scrollingInProgress), map(function (_ref67) {
    var _ref68 = _slicedToArray(_ref67, 5),
      _ref68$ = _slicedToArray(_ref68[0], 2),
      totalCount2 = _ref68$[0],
      didMount2 = _ref68$[1],
      followOutput2 = _ref68[1],
      isAtBottom2 = _ref68[2],
      scrolledToInitialItem2 = _ref68[3],
      scrollingInProgress2 = _ref68[4];
    var shouldFollow = didMount2 && scrolledToInitialItem2;
    var followOutputBehavior = "auto";
    if (shouldFollow) {
      followOutputBehavior = behaviorFromFollowOutput(followOutput2, isAtBottom2 || scrollingInProgress2);
      shouldFollow = shouldFollow && !!followOutputBehavior;
    }
    return {
      totalCount: totalCount2,
      shouldFollow: shouldFollow,
      followOutputBehavior: followOutputBehavior
    };
  }), filter(function (_ref69) {
    var shouldFollow = _ref69.shouldFollow;
    return shouldFollow;
  })), function (_ref70) {
    var totalCount2 = _ref70.totalCount,
      followOutputBehavior = _ref70.followOutputBehavior;
    if (pendingScrollHandle) {
      pendingScrollHandle();
      pendingScrollHandle = null;
    }
    pendingScrollHandle = handleNext(listRefresh, function () {
      getValue(log)("following output to ", {
        totalCount: totalCount2
      }, LogLevel.DEBUG);
      scrollToBottom(followOutputBehavior);
      pendingScrollHandle = null;
    });
  });
  function trapNextSizeIncrease(followOutput2) {
    var cancel = handleNext(atBottomState, function (state) {
      if (followOutput2 && !state.atBottom && state.notAtBottomBecause === "SIZE_INCREASED" && !pendingScrollHandle) {
        getValue(log)("scrolling to bottom due to increased size", {}, LogLevel.DEBUG);
        scrollToBottom("auto");
      }
    });
    setTimeout(cancel, 100);
  }
  subscribe(pipe(combineLatest(duc(followOutput), totalCount, propsReady), filter(function (_ref71) {
    var _ref72 = _slicedToArray(_ref71, 3),
      follow = _ref72[0],
      ready = _ref72[2];
    return follow && ready;
  }), scan(function (_ref73, _ref74) {
    var value = _ref73.value;
    var _ref75 = _slicedToArray(_ref74, 2),
      next = _ref75[1];
    return {
      refreshed: value === next,
      value: next
    };
  }, {
    refreshed: false,
    value: 0
  }), filter(function (_ref76) {
    var refreshed = _ref76.refreshed;
    return refreshed;
  }), withLatestFrom(followOutput, totalCount)), function (_ref77) {
    var _ref78 = _slicedToArray(_ref77, 2),
      followOutput2 = _ref78[1];
    trapNextSizeIncrease(followOutput2 !== false);
  });
  subscribe(autoscrollToBottom, function () {
    trapNextSizeIncrease(getValue(followOutput) !== false);
  });
  subscribe(combineLatest(duc(followOutput), atBottomState), function (_ref79) {
    var _ref80 = _slicedToArray(_ref79, 2),
      followOutput2 = _ref80[0],
      state = _ref80[1];
    if (followOutput2 && !state.atBottom && state.notAtBottomBecause === "VIEWPORT_HEIGHT_DECREASING") {
      scrollToBottom("auto");
    }
  });
  return {
    followOutput: followOutput,
    autoscrollToBottom: autoscrollToBottom
  };
}, tup(sizeSystem, stateFlagsSystem, scrollToIndexSystem, initialTopMostItemIndexSystem, propsReadySystem, loggerSystem, domIOSystem));
function groupCountsToIndicesAndCount(counts) {
  return counts.reduce(function (acc, groupCount) {
    acc.groupIndices.push(acc.totalCount);
    acc.totalCount += groupCount + 1;
    return acc;
  }, {
    totalCount: 0,
    groupIndices: []
  });
}
var groupedListSystem = system(function (_ref81) {
  var _ref82 = _slicedToArray(_ref81, 2),
    _ref82$ = _ref82[0],
    totalCount = _ref82$.totalCount,
    groupIndices = _ref82$.groupIndices,
    sizes = _ref82$.sizes,
    _ref82$2 = _ref82[1],
    scrollTop = _ref82$2.scrollTop,
    headerHeight = _ref82$2.headerHeight;
  var groupCounts = stream();
  var topItemsIndexes = stream();
  var groupIndicesAndCount = streamFromEmitter(pipe(groupCounts, map(groupCountsToIndicesAndCount)));
  connect(pipe(groupIndicesAndCount, map(function (value) {
    return value.totalCount;
  })), totalCount);
  connect(pipe(groupIndicesAndCount, map(function (value) {
    return value.groupIndices;
  })), groupIndices);
  connect(pipe(combineLatest(scrollTop, sizes, headerHeight), filter(function (_ref83) {
    var _ref84 = _slicedToArray(_ref83, 2),
      _ = _ref84[0],
      sizes2 = _ref84[1];
    return hasGroups(sizes2);
  }), map(function (_ref85) {
    var _ref86 = _slicedToArray(_ref85, 3),
      scrollTop2 = _ref86[0],
      state = _ref86[1],
      headerHeight2 = _ref86[2];
    return findMaxKeyValue(state.groupOffsetTree, Math.max(scrollTop2 - headerHeight2, 0), "v")[0];
  }), distinctUntilChanged(), map(function (index) {
    return [index];
  })), topItemsIndexes);
  return {
    groupCounts: groupCounts,
    topItemsIndexes: topItemsIndexes
  };
}, tup(sizeSystem, domIOSystem));
function tupleComparator(prev, current) {
  return !!(prev && prev[0] === current[0] && prev[1] === current[1]);
}
function rangeComparator(prev, next) {
  return !!(prev && prev.startIndex === next.startIndex && prev.endIndex === next.endIndex);
}
var TOP = "top";
var BOTTOM = "bottom";
var NONE = "none";
function getOverscan(overscan, end, direction) {
  if (typeof overscan === "number") {
    return direction === UP && end === TOP || direction === DOWN && end === BOTTOM ? overscan : 0;
  } else {
    if (direction === UP) {
      return end === TOP ? overscan.main : overscan.reverse;
    } else {
      return end === BOTTOM ? overscan.main : overscan.reverse;
    }
  }
}
function getViewportIncrease(value, end) {
  return typeof value === "number" ? value : value[end] || 0;
}
var sizeRangeSystem = system(function (_ref87) {
  var _ref88 = _slicedToArray(_ref87, 1),
    _ref88$ = _ref88[0],
    scrollTop = _ref88$.scrollTop,
    viewportHeight = _ref88$.viewportHeight,
    deviation = _ref88$.deviation,
    headerHeight = _ref88$.headerHeight,
    fixedHeaderHeight = _ref88$.fixedHeaderHeight;
  var listBoundary = stream();
  var topListHeight = statefulStream(0);
  var increaseViewportBy = statefulStream(0);
  var overscan = statefulStream(0);
  var visibleRange = statefulStreamFromEmitter(pipe(combineLatest(duc(scrollTop), duc(viewportHeight), duc(headerHeight), duc(listBoundary, tupleComparator), duc(overscan), duc(topListHeight), duc(fixedHeaderHeight), duc(deviation), duc(increaseViewportBy)), map(function (_ref89) {
    var _ref90 = _slicedToArray(_ref89, 9),
      scrollTop2 = _ref90[0],
      viewportHeight2 = _ref90[1],
      headerHeight2 = _ref90[2],
      _ref90$ = _slicedToArray(_ref90[3], 2),
      listTop = _ref90$[0],
      listBottom = _ref90$[1],
      overscan2 = _ref90[4],
      topListHeight2 = _ref90[5],
      fixedHeaderHeight2 = _ref90[6],
      deviation2 = _ref90[7],
      increaseViewportBy2 = _ref90[8];
    var top = scrollTop2 - deviation2;
    var stickyHeaderHeight = topListHeight2 + fixedHeaderHeight2;
    var headerVisible = Math.max(headerHeight2 - top, 0);
    var direction = NONE;
    var topViewportAddition = getViewportIncrease(increaseViewportBy2, TOP);
    var bottomViewportAddition = getViewportIncrease(increaseViewportBy2, BOTTOM);
    listTop -= deviation2;
    listTop += headerHeight2 + fixedHeaderHeight2;
    listBottom += headerHeight2 + fixedHeaderHeight2;
    listBottom -= deviation2;
    if (listTop > scrollTop2 + stickyHeaderHeight - topViewportAddition) {
      direction = UP;
    }
    if (listBottom < scrollTop2 - headerVisible + viewportHeight2 + bottomViewportAddition) {
      direction = DOWN;
    }
    if (direction !== NONE) {
      return [Math.max(top - headerHeight2 - getOverscan(overscan2, TOP, direction) - topViewportAddition, 0), top - headerVisible - fixedHeaderHeight2 + viewportHeight2 + getOverscan(overscan2, BOTTOM, direction) + bottomViewportAddition];
    }
    return null;
  }), filter(function (value) {
    return value != null;
  }), distinctUntilChanged(tupleComparator)), [0, 0]);
  return {
    // input
    listBoundary: listBoundary,
    overscan: overscan,
    topListHeight: topListHeight,
    increaseViewportBy: increaseViewportBy,
    // output
    visibleRange: visibleRange
  };
}, tup(domIOSystem), {
  singleton: true
});
function probeItemSet(index, sizes, data) {
  if (hasGroups(sizes)) {
    var itemIndex = originalIndexFromItemIndex(index, sizes);
    var groupIndex = findMaxKeyValue(sizes.groupOffsetTree, itemIndex)[0];
    return [{
      index: groupIndex,
      size: 0,
      offset: 0
    }, {
      index: itemIndex,
      size: 0,
      offset: 0,
      data: data && data[0]
    }];
  }
  return [{
    index: index,
    size: 0,
    offset: 0,
    data: data && data[0]
  }];
}
var EMPTY_LIST_STATE = {
  items: [],
  topItems: [],
  offsetTop: 0,
  offsetBottom: 0,
  top: 0,
  bottom: 0,
  topListHeight: 0,
  totalCount: 0,
  firstItemIndex: 0
};
function transposeItems(items, sizes, firstItemIndex) {
  if (items.length === 0) {
    return [];
  }
  if (!hasGroups(sizes)) {
    return items.map(function (item) {
      return _objectSpread(_objectSpread({}, item), {}, {
        index: item.index + firstItemIndex,
        originalIndex: item.index
      });
    });
  }
  var startIndex = items[0].index;
  var endIndex = items[items.length - 1].index;
  var transposedItems = [];
  var groupRanges = rangesWithin(sizes.groupOffsetTree, startIndex, endIndex);
  var currentRange = void 0;
  var currentGroupIndex = 0;
  var _iterator4 = _createForOfIteratorHelper(items),
    _step4;
  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var item = _step4.value;
      if (!currentRange || currentRange.end < item.index) {
        currentRange = groupRanges.shift();
        currentGroupIndex = sizes.groupIndices.indexOf(currentRange.start);
      }
      var transposedItem = void 0;
      if (item.index === currentRange.start) {
        transposedItem = {
          type: "group",
          index: currentGroupIndex
        };
      } else {
        transposedItem = {
          index: item.index - (currentGroupIndex + 1) + firstItemIndex,
          groupIndex: currentGroupIndex
        };
      }
      transposedItems.push(_objectSpread(_objectSpread({}, transposedItem), {}, {
        size: item.size,
        offset: item.offset,
        originalIndex: item.index,
        data: item.data
      }));
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }
  return transposedItems;
}
function buildListState(items, topItems, totalCount, gap, sizes, firstItemIndex) {
  var lastSize = sizes.lastSize,
    lastOffset = sizes.lastOffset,
    lastIndex = sizes.lastIndex;
  var offsetTop = 0;
  var bottom = 0;
  if (items.length > 0) {
    offsetTop = items[0].offset;
    var lastItem = items[items.length - 1];
    bottom = lastItem.offset + lastItem.size;
  }
  var itemCount = totalCount - lastIndex;
  var total = lastOffset + itemCount * lastSize + (itemCount - 1) * gap;
  var top = offsetTop;
  var offsetBottom = total - bottom;
  return {
    items: transposeItems(items, sizes, firstItemIndex),
    topItems: transposeItems(topItems, sizes, firstItemIndex),
    topListHeight: topItems.reduce(function (height, item) {
      return item.size + height;
    }, 0),
    offsetTop: offsetTop,
    offsetBottom: offsetBottom,
    top: top,
    bottom: bottom,
    totalCount: totalCount,
    firstItemIndex: firstItemIndex
  };
}
function buildListStateFromItemCount(itemCount, initialTopMostItemIndex, sizes, firstItemIndex, gap, data) {
  var includedGroupsCount = 0;
  if (sizes.groupIndices.length > 0) {
    var _iterator5 = _createForOfIteratorHelper(sizes.groupIndices),
      _step5;
    try {
      for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
        var index = _step5.value;
        if (index - includedGroupsCount >= itemCount) {
          break;
        }
        includedGroupsCount++;
      }
    } catch (err) {
      _iterator5.e(err);
    } finally {
      _iterator5.f();
    }
  }
  var adjustedCount = itemCount + includedGroupsCount;
  var initialTopMostItemIndexNumber = getInitialTopMostItemIndexNumber(initialTopMostItemIndex, adjustedCount);
  var items = Array.from({
    length: adjustedCount
  }).map(function (_, index) {
    return {
      index: index + initialTopMostItemIndexNumber,
      size: 0,
      offset: 0,
      data: data[index + initialTopMostItemIndexNumber]
    };
  });
  return buildListState(items, [], adjustedCount, gap, sizes, firstItemIndex);
}
var listStateSystem = system(function (_ref91) {
  var _ref92 = _slicedToArray(_ref91, 8),
    _ref92$ = _ref92[0],
    sizes = _ref92$.sizes,
    totalCount = _ref92$.totalCount,
    data = _ref92$.data,
    firstItemIndex = _ref92$.firstItemIndex,
    gap = _ref92$.gap,
    groupedListSystem2 = _ref92[1],
    _ref92$2 = _ref92[2],
    visibleRange = _ref92$2.visibleRange,
    listBoundary = _ref92$2.listBoundary,
    rangeTopListHeight = _ref92$2.topListHeight,
    _ref92$3 = _ref92[3],
    scrolledToInitialItem = _ref92$3.scrolledToInitialItem,
    initialTopMostItemIndex = _ref92$3.initialTopMostItemIndex,
    topListHeight = _ref92[4].topListHeight,
    stateFlags = _ref92[5],
    didMount = _ref92[6].didMount,
    recalcInProgress = _ref92[7].recalcInProgress;
  var topItemsIndexes = statefulStream([]);
  var initialItemCount = statefulStream(0);
  var itemsRendered = stream();
  connect(groupedListSystem2.topItemsIndexes, topItemsIndexes);
  var listState = statefulStreamFromEmitter(pipe(combineLatest(didMount, recalcInProgress, duc(visibleRange, tupleComparator), duc(totalCount), duc(sizes), duc(initialTopMostItemIndex), scrolledToInitialItem, duc(topItemsIndexes), duc(firstItemIndex), duc(gap), data), filter(function (_ref93) {
    var _ref94 = _slicedToArray(_ref93, 11),
      mount = _ref94[0],
      recalcInProgress2 = _ref94[1],
      totalCount2 = _ref94[3],
      data2 = _ref94[10];
    var dataChangeInProgress = data2 && data2.length !== totalCount2;
    return mount && !recalcInProgress2 && !dataChangeInProgress;
  }), map(function (_ref95) {
    var _ref96 = _slicedToArray(_ref95, 11),
      _ref96$ = _slicedToArray(_ref96[2], 2),
      startOffset = _ref96$[0],
      endOffset = _ref96$[1],
      totalCount2 = _ref96[3],
      sizes2 = _ref96[4],
      initialTopMostItemIndex2 = _ref96[5],
      scrolledToInitialItem2 = _ref96[6],
      topItemsIndexes2 = _ref96[7],
      firstItemIndex2 = _ref96[8],
      gap2 = _ref96[9],
      data2 = _ref96[10];
    var sizesValue = sizes2;
    var sizeTree = sizesValue.sizeTree,
      offsetTree = sizesValue.offsetTree;
    var initialItemCountValue = getValue(initialItemCount);
    if (totalCount2 === 0) {
      return _objectSpread(_objectSpread({}, EMPTY_LIST_STATE), {}, {
        totalCount: totalCount2
      });
    }
    if (startOffset === 0 && endOffset === 0) {
      if (initialItemCountValue === 0) {
        return _objectSpread(_objectSpread({}, EMPTY_LIST_STATE), {}, {
          totalCount: totalCount2
        });
      } else {
        return buildListStateFromItemCount(initialItemCountValue, initialTopMostItemIndex2, sizes2, firstItemIndex2, gap2, data2 || []);
      }
    }
    if (empty(sizeTree)) {
      if (initialItemCountValue > 0) {
        return null;
      }
      var state = buildListState(probeItemSet(getInitialTopMostItemIndexNumber(initialTopMostItemIndex2, totalCount2), sizesValue, data2), [], totalCount2, gap2, sizesValue, firstItemIndex2);
      return state;
    }
    var topItems = [];
    if (topItemsIndexes2.length > 0) {
      var startIndex = topItemsIndexes2[0];
      var endIndex = topItemsIndexes2[topItemsIndexes2.length - 1];
      var offset = 0;
      var _iterator6 = _createForOfIteratorHelper(rangesWithin(sizeTree, startIndex, endIndex)),
        _step6;
      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var range = _step6.value;
          var size = range.value;
          var rangeStartIndex = Math.max(range.start, startIndex);
          var rangeEndIndex = Math.min(range.end, endIndex);
          for (var i = rangeStartIndex; i <= rangeEndIndex; i++) {
            topItems.push({
              index: i,
              size: size,
              offset: offset,
              data: data2 && data2[i]
            });
            offset += size;
          }
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
    }
    if (!scrolledToInitialItem2) {
      return buildListState([], topItems, totalCount2, gap2, sizesValue, firstItemIndex2);
    }
    var minStartIndex = topItemsIndexes2.length > 0 ? topItemsIndexes2[topItemsIndexes2.length - 1] + 1 : 0;
    var offsetPointRanges = rangesWithinOffsets(offsetTree, startOffset, endOffset, minStartIndex);
    if (offsetPointRanges.length === 0) {
      return null;
    }
    var maxIndex = totalCount2 - 1;
    var items = tap([], function (result) {
      var _iterator7 = _createForOfIteratorHelper(offsetPointRanges),
        _step7;
      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var _range = _step7.value;
          var point = _range.value;
          var _offset = point.offset;
          var _rangeStartIndex = _range.start;
          var _size = point.size;
          if (point.offset < startOffset) {
            _rangeStartIndex += Math.floor((startOffset - point.offset + gap2) / (_size + gap2));
            var itemCount = _rangeStartIndex - _range.start;
            _offset += itemCount * _size + itemCount * gap2;
          }
          if (_rangeStartIndex < minStartIndex) {
            _offset += (minStartIndex - _rangeStartIndex) * _size;
            _rangeStartIndex = minStartIndex;
          }
          var _endIndex = Math.min(_range.end, maxIndex);
          for (var _i4 = _rangeStartIndex; _i4 <= _endIndex; _i4++) {
            if (_offset >= endOffset) {
              break;
            }
            result.push({
              index: _i4,
              size: _size,
              offset: _offset,
              data: data2 && data2[_i4]
            });
            _offset += _size + gap2;
          }
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }
    });
    return buildListState(items, topItems, totalCount2, gap2, sizesValue, firstItemIndex2);
  }),
  //@ts-expect-error filter needs to be fixed
  filter(function (value) {
    return value !== null;
  }), distinctUntilChanged()), EMPTY_LIST_STATE);
  connect(pipe(data, filter(isDefined), map(function (data2) {
    return data2 == null ? void 0 : data2.length;
  })), totalCount);
  connect(pipe(listState, map(function (value) {
    return value.topListHeight;
  })), topListHeight);
  connect(topListHeight, rangeTopListHeight);
  connect(pipe(listState, map(function (state) {
    return [state.top, state.bottom];
  })), listBoundary);
  connect(pipe(listState, map(function (state) {
    return state.items;
  })), itemsRendered);
  var endReached = streamFromEmitter(pipe(listState, filter(function (_ref97) {
    var items = _ref97.items;
    return items.length > 0;
  }), withLatestFrom(totalCount, data), filter(function (_ref98) {
    var _ref99 = _slicedToArray(_ref98, 2),
      items = _ref99[0].items,
      totalCount2 = _ref99[1];
    return items[items.length - 1].originalIndex === totalCount2 - 1;
  }), map(function (_ref100) {
    var _ref101 = _slicedToArray(_ref100, 3),
      totalCount2 = _ref101[1],
      data2 = _ref101[2];
    return [totalCount2 - 1, data2];
  }), distinctUntilChanged(tupleComparator), map(function (_ref102) {
    var _ref103 = _slicedToArray(_ref102, 1),
      count = _ref103[0];
    return count;
  })));
  var startReached = streamFromEmitter(pipe(listState, throttleTime(200), filter(function (_ref104) {
    var items = _ref104.items,
      topItems = _ref104.topItems;
    return items.length > 0 && items[0].originalIndex === topItems.length;
  }), map(function (_ref105) {
    var items = _ref105.items;
    return items[0].index;
  }), distinctUntilChanged()));
  var rangeChanged = streamFromEmitter(pipe(listState, filter(function (_ref106) {
    var items = _ref106.items;
    return items.length > 0;
  }), map(function (_ref107) {
    var items = _ref107.items;
    var startIndex = 0;
    var endIndex = items.length - 1;
    while (items[startIndex].type === "group" && startIndex < endIndex) {
      startIndex++;
    }
    while (items[endIndex].type === "group" && endIndex > startIndex) {
      endIndex--;
    }
    return {
      startIndex: items[startIndex].index,
      endIndex: items[endIndex].index
    };
  }), distinctUntilChanged(rangeComparator)));
  return _objectSpread({
    listState: listState,
    topItemsIndexes: topItemsIndexes,
    endReached: endReached,
    startReached: startReached,
    rangeChanged: rangeChanged,
    itemsRendered: itemsRendered,
    initialItemCount: initialItemCount
  }, stateFlags);
}, tup(sizeSystem, groupedListSystem, sizeRangeSystem, initialTopMostItemIndexSystem, scrollToIndexSystem, stateFlagsSystem, propsReadySystem, recalcSystem), {
  singleton: true
});
var initialItemCountSystem = system(function (_ref108) {
  var _ref109 = _slicedToArray(_ref108, 4),
    _ref109$ = _ref109[0],
    sizes = _ref109$.sizes,
    firstItemIndex = _ref109$.firstItemIndex,
    data = _ref109$.data,
    gap = _ref109$.gap,
    initialTopMostItemIndex = _ref109[1].initialTopMostItemIndex,
    _ref109$2 = _ref109[2],
    initialItemCount = _ref109$2.initialItemCount,
    listState = _ref109$2.listState,
    didMount = _ref109[3].didMount;
  connect(pipe(didMount, withLatestFrom(initialItemCount), filter(function (_ref110) {
    var _ref111 = _slicedToArray(_ref110, 2),
      count = _ref111[1];
    return count !== 0;
  }), withLatestFrom(initialTopMostItemIndex, sizes, firstItemIndex, gap, data), map(function (_ref112) {
    var _ref113 = _slicedToArray(_ref112, 6),
      _ref113$ = _slicedToArray(_ref113[0], 2),
      count = _ref113$[1],
      initialTopMostItemIndexValue = _ref113[1],
      sizes2 = _ref113[2],
      firstItemIndex2 = _ref113[3],
      gap2 = _ref113[4],
      _ref113$2 = _ref113[5],
      data2 = _ref113$2 === void 0 ? [] : _ref113$2;
    return buildListStateFromItemCount(count, initialTopMostItemIndexValue, sizes2, firstItemIndex2, gap2, data2);
  })), listState);
  return {};
}, tup(sizeSystem, initialTopMostItemIndexSystem, listStateSystem, propsReadySystem), {
  singleton: true
});
var scrollSeekSystem = system(function (_ref114) {
  var _ref115 = _slicedToArray(_ref114, 1),
    scrollVelocity = _ref115[0].scrollVelocity;
  var isSeeking = statefulStream(false);
  var rangeChanged = stream();
  var scrollSeekConfiguration = statefulStream(false);
  connect(pipe(scrollVelocity, withLatestFrom(scrollSeekConfiguration, isSeeking, rangeChanged), filter(function (_ref116) {
    var _ref117 = _slicedToArray(_ref116, 2),
      _ = _ref117[0],
      config = _ref117[1];
    return !!config;
  }), map(function (_ref118) {
    var _ref119 = _slicedToArray(_ref118, 4),
      speed = _ref119[0],
      config = _ref119[1],
      isSeeking2 = _ref119[2],
      range = _ref119[3];
    var exit = config.exit,
      enter = config.enter;
    if (isSeeking2) {
      if (exit(speed, range)) {
        return false;
      }
    } else {
      if (enter(speed, range)) {
        return true;
      }
    }
    return isSeeking2;
  }), distinctUntilChanged()), isSeeking);
  subscribe(pipe(combineLatest(isSeeking, scrollVelocity, rangeChanged), withLatestFrom(scrollSeekConfiguration)), function (_ref120) {
    var _ref121 = _slicedToArray(_ref120, 2),
      _ref121$ = _slicedToArray(_ref121[0], 3),
      isSeeking2 = _ref121$[0],
      velocity = _ref121$[1],
      range = _ref121$[2],
      config = _ref121[1];
    return isSeeking2 && config && config.change && config.change(velocity, range);
  });
  return {
    isSeeking: isSeeking,
    scrollSeekConfiguration: scrollSeekConfiguration,
    scrollVelocity: scrollVelocity,
    scrollSeekRangeChanged: rangeChanged
  };
}, tup(stateFlagsSystem), {
  singleton: true
});
var topItemCountSystem = system(function (_ref122) {
  var _ref123 = _slicedToArray(_ref122, 1),
    topItemsIndexes = _ref123[0].topItemsIndexes;
  var topItemCount = statefulStream(0);
  connect(pipe(topItemCount, filter(function (length) {
    return length > 0;
  }), map(function (length) {
    return Array.from({
      length: length
    }).map(function (_, index) {
      return index;
    });
  })), topItemsIndexes);
  return {
    topItemCount: topItemCount
  };
}, tup(listStateSystem));
var totalListHeightSystem = system(function (_ref124) {
  var _ref125 = _slicedToArray(_ref124, 2),
    _ref125$ = _ref125[0],
    footerHeight = _ref125$.footerHeight,
    headerHeight = _ref125$.headerHeight,
    fixedHeaderHeight = _ref125$.fixedHeaderHeight,
    fixedFooterHeight = _ref125$.fixedFooterHeight,
    listState = _ref125[1].listState;
  var totalListHeightChanged = stream();
  var totalListHeight = statefulStreamFromEmitter(pipe(combineLatest(footerHeight, fixedFooterHeight, headerHeight, fixedHeaderHeight, listState), map(function (_ref126) {
    var _ref127 = _slicedToArray(_ref126, 5),
      footerHeight2 = _ref127[0],
      fixedFooterHeight2 = _ref127[1],
      headerHeight2 = _ref127[2],
      fixedHeaderHeight2 = _ref127[3],
      listState2 = _ref127[4];
    return footerHeight2 + fixedFooterHeight2 + headerHeight2 + fixedHeaderHeight2 + listState2.offsetBottom + listState2.bottom;
  })), 0);
  connect(duc(totalListHeight), totalListHeightChanged);
  return {
    totalListHeight: totalListHeight,
    totalListHeightChanged: totalListHeightChanged
  };
}, tup(domIOSystem, listStateSystem), {
  singleton: true
});
function simpleMemoize(func) {
  var called = false;
  var result;
  return function () {
    if (!called) {
      called = true;
      result = func();
    }
    return result;
  };
}
var isMobileSafari = simpleMemoize(function () {
  return /iP(ad|od|hone)/i.test(navigator.userAgent) && /WebKit/i.test(navigator.userAgent);
});
var upwardScrollFixSystem = system(function (_ref128) {
  var _ref129 = _slicedToArray(_ref128, 6),
    _ref129$ = _ref129[0],
    scrollBy = _ref129$.scrollBy,
    scrollTop = _ref129$.scrollTop,
    deviation = _ref129$.deviation,
    scrollingInProgress = _ref129$.scrollingInProgress,
    _ref129$2 = _ref129[1],
    isScrolling = _ref129$2.isScrolling,
    isAtBottom = _ref129$2.isAtBottom,
    scrollDirection = _ref129$2.scrollDirection,
    lastJumpDueToItemResize = _ref129$2.lastJumpDueToItemResize,
    listState = _ref129[2].listState,
    _ref129$3 = _ref129[3],
    beforeUnshiftWith = _ref129$3.beforeUnshiftWith,
    shiftWithOffset = _ref129$3.shiftWithOffset,
    sizes = _ref129$3.sizes,
    gap = _ref129$3.gap,
    log = _ref129[4].log,
    recalcInProgress = _ref129[5].recalcInProgress;
  var deviationOffset = streamFromEmitter(pipe(listState, withLatestFrom(lastJumpDueToItemResize), scan(function (_ref130, _ref131) {
    var _ref132 = _slicedToArray(_ref130, 4),
      prevItems = _ref132[1],
      prevTotalCount = _ref132[2],
      prevTotalHeight = _ref132[3];
    var _ref133 = _slicedToArray(_ref131, 2),
      _ref133$ = _ref133[0],
      items = _ref133$.items,
      totalCount = _ref133$.totalCount,
      bottom = _ref133$.bottom,
      offsetBottom = _ref133$.offsetBottom,
      lastJumpDueToItemResize2 = _ref133[1];
    var totalHeight = bottom + offsetBottom;
    var newDev = 0;
    if (prevTotalCount === totalCount) {
      if (prevItems.length > 0 && items.length > 0) {
        var atStart = items[0].originalIndex === 0 && prevItems[0].originalIndex === 0;
        if (!atStart) {
          newDev = totalHeight - prevTotalHeight;
          if (newDev !== 0) {
            newDev += lastJumpDueToItemResize2;
          }
        }
      }
    }
    return [newDev, items, totalCount, totalHeight];
  }, [0, [], 0, 0]), filter(function (_ref134) {
    var _ref135 = _slicedToArray(_ref134, 1),
      amount = _ref135[0];
    return amount !== 0;
  }), withLatestFrom(scrollTop, scrollDirection, scrollingInProgress, isAtBottom, log, recalcInProgress), filter(function (_ref136) {
    var _ref137 = _slicedToArray(_ref136, 7),
      scrollTop2 = _ref137[1],
      scrollDirection2 = _ref137[2],
      scrollingInProgress2 = _ref137[3],
      recalcInProgress2 = _ref137[6];
    return !recalcInProgress2 && !scrollingInProgress2 && scrollTop2 !== 0 && scrollDirection2 === UP;
  }), map(function (_ref138) {
    var _ref139 = _slicedToArray(_ref138, 6),
      _ref139$ = _slicedToArray(_ref139[0], 1),
      amount = _ref139$[0],
      log2 = _ref139[5];
    log2("Upward scrolling compensation", {
      amount: amount
    }, LogLevel.DEBUG);
    return amount;
  })));
  function scrollByWith(offset) {
    if (offset > 0) {
      publish(scrollBy, {
        top: -offset,
        behavior: "auto"
      });
      publish(deviation, 0);
    } else {
      publish(deviation, 0);
      publish(scrollBy, {
        top: -offset,
        behavior: "auto"
      });
    }
  }
  subscribe(pipe(deviationOffset, withLatestFrom(deviation, isScrolling)), function (_ref140) {
    var _ref141 = _slicedToArray(_ref140, 3),
      offset = _ref141[0],
      deviationAmount = _ref141[1],
      isScrolling2 = _ref141[2];
    if (isScrolling2 && isMobileSafari()) {
      publish(deviation, deviationAmount - offset);
    } else {
      scrollByWith(-offset);
    }
  });
  subscribe(pipe(combineLatest(statefulStreamFromEmitter(isScrolling, false), deviation, recalcInProgress), filter(function (_ref142) {
    var _ref143 = _slicedToArray(_ref142, 3),
      is = _ref143[0],
      deviation2 = _ref143[1],
      recalc = _ref143[2];
    return !is && !recalc && deviation2 !== 0;
  }), map(function (_ref144) {
    var _ref145 = _slicedToArray(_ref144, 2),
      _ = _ref145[0],
      deviation2 = _ref145[1];
    return deviation2;
  }), throttleTime(1)), scrollByWith);
  connect(pipe(shiftWithOffset, map(function (offset) {
    return {
      top: -offset
    };
  })), scrollBy);
  subscribe(pipe(beforeUnshiftWith, withLatestFrom(sizes, gap), map(function (_ref146) {
    var _ref147 = _slicedToArray(_ref146, 3),
      offset = _ref147[0],
      _ref147$ = _ref147[1],
      defaultItemSize = _ref147$.lastSize,
      groupIndices = _ref147$.groupIndices,
      sizeTree = _ref147$.sizeTree,
      gap2 = _ref147[2];
    function getItemOffset(itemCount) {
      return itemCount * (defaultItemSize + gap2);
    }
    if (groupIndices.length === 0) {
      return getItemOffset(offset);
    } else {
      var amount = 0;
      var defaultGroupSize = find(sizeTree, 0);
      var recognizedOffsetItems = 0;
      var groupIndex = 0;
      while (recognizedOffsetItems < offset) {
        recognizedOffsetItems++;
        amount += defaultGroupSize;
        var groupItemCount = groupIndices.length === groupIndex + 1 ? Infinity : groupIndices[groupIndex + 1] - groupIndices[groupIndex] - 1;
        if (recognizedOffsetItems + groupItemCount > offset) {
          amount -= defaultGroupSize;
          groupItemCount = offset - recognizedOffsetItems + 1;
        }
        recognizedOffsetItems += groupItemCount;
        amount += getItemOffset(groupItemCount);
        groupIndex++;
      }
      return amount;
    }
  })), function (offset) {
    publish(deviation, offset);
    requestAnimationFrame(function () {
      publish(scrollBy, {
        top: offset
      });
      requestAnimationFrame(function () {
        publish(deviation, 0);
        publish(recalcInProgress, false);
      });
    });
  });
  return {
    deviation: deviation
  };
}, tup(domIOSystem, stateFlagsSystem, listStateSystem, sizeSystem, loggerSystem, recalcSystem));
var initialScrollTopSystem = system(function (_ref148) {
  var _ref149 = _slicedToArray(_ref148, 3),
    didMount = _ref149[0].didMount,
    scrollTo = _ref149[1].scrollTo,
    listState = _ref149[2].listState;
  var initialScrollTop = statefulStream(0);
  subscribe(pipe(didMount, withLatestFrom(initialScrollTop), filter(function (_ref150) {
    var _ref151 = _slicedToArray(_ref150, 2),
      offset = _ref151[1];
    return offset !== 0;
  }), map(function (_ref152) {
    var _ref153 = _slicedToArray(_ref152, 2),
      offset = _ref153[1];
    return {
      top: offset
    };
  })), function (location) {
    handleNext(pipe(listState, skip(1), filter(function (state) {
      return state.items.length > 1;
    })), function () {
      requestAnimationFrame(function () {
        publish(scrollTo, location);
      });
    });
  });
  return {
    initialScrollTop: initialScrollTop
  };
}, tup(propsReadySystem, domIOSystem, listStateSystem), {
  singleton: true
});
var alignToBottomSystem = system(function (_ref154) {
  var _ref155 = _slicedToArray(_ref154, 2),
    viewportHeight = _ref155[0].viewportHeight,
    totalListHeight = _ref155[1].totalListHeight;
  var alignToBottom = statefulStream(false);
  var paddingTopAddition = statefulStreamFromEmitter(pipe(combineLatest(alignToBottom, viewportHeight, totalListHeight), filter(function (_ref156) {
    var _ref157 = _slicedToArray(_ref156, 1),
      enabled = _ref157[0];
    return enabled;
  }), map(function (_ref158) {
    var _ref159 = _slicedToArray(_ref158, 3),
      viewportHeight2 = _ref159[1],
      totalListHeight2 = _ref159[2];
    return Math.max(0, viewportHeight2 - totalListHeight2);
  }), throttleTime(0), distinctUntilChanged()), 0);
  return {
    alignToBottom: alignToBottom,
    paddingTopAddition: paddingTopAddition
  };
}, tup(domIOSystem, totalListHeightSystem), {
  singleton: true
});
var windowScrollerSystem = system(function (_ref160) {
  var _ref161 = _slicedToArray(_ref160, 1),
    _ref161$ = _ref161[0],
    scrollTo = _ref161$.scrollTo,
    scrollContainerState = _ref161$.scrollContainerState;
  var windowScrollContainerState = stream();
  var windowViewportRect = stream();
  var windowScrollTo = stream();
  var useWindowScroll = statefulStream(false);
  var customScrollParent = statefulStream(void 0);
  connect(pipe(combineLatest(windowScrollContainerState, windowViewportRect), map(function (_ref162) {
    var _ref163 = _slicedToArray(_ref162, 2),
      _ref163$ = _ref163[0],
      viewportHeight = _ref163$.viewportHeight,
      windowScrollTop = _ref163$.scrollTop,
      scrollHeight = _ref163$.scrollHeight,
      offsetTop = _ref163[1].offsetTop;
    return {
      scrollTop: Math.max(0, windowScrollTop - offsetTop),
      scrollHeight: scrollHeight,
      viewportHeight: viewportHeight
    };
  })), scrollContainerState);
  connect(pipe(scrollTo, withLatestFrom(windowViewportRect), map(function (_ref164) {
    var _ref165 = _slicedToArray(_ref164, 2),
      scrollTo2 = _ref165[0],
      offsetTop = _ref165[1].offsetTop;
    return _objectSpread(_objectSpread({}, scrollTo2), {}, {
      top: scrollTo2.top + offsetTop
    });
  })), windowScrollTo);
  return {
    // config
    useWindowScroll: useWindowScroll,
    customScrollParent: customScrollParent,
    // input
    windowScrollContainerState: windowScrollContainerState,
    windowViewportRect: windowViewportRect,
    // signals
    windowScrollTo: windowScrollTo
  };
}, tup(domIOSystem));
var defaultCalculateViewLocation = function defaultCalculateViewLocation(_ref166) {
  var itemTop2 = _ref166.itemTop,
    itemBottom = _ref166.itemBottom,
    viewportTop = _ref166.viewportTop,
    viewportBottom = _ref166.viewportBottom,
    _ref166$locationParam = _ref166.locationParams,
    behavior = _ref166$locationParam.behavior,
    align = _ref166$locationParam.align,
    rest = _objectWithoutProperties(_ref166$locationParam, _excluded2);
  if (itemTop2 < viewportTop) {
    return _objectSpread(_objectSpread({}, rest), {}, {
      behavior: behavior,
      align: align != null ? align : "start"
    });
  }
  if (itemBottom > viewportBottom) {
    return _objectSpread(_objectSpread({}, rest), {}, {
      behavior: behavior,
      align: align != null ? align : "end"
    });
  }
  return null;
};
var scrollIntoViewSystem = system(function (_ref167) {
  var _ref168 = _slicedToArray(_ref167, 3),
    _ref168$ = _ref168[0],
    sizes = _ref168$.sizes,
    totalCount = _ref168$.totalCount,
    gap = _ref168$.gap,
    _ref168$2 = _ref168[1],
    scrollTop = _ref168$2.scrollTop,
    viewportHeight = _ref168$2.viewportHeight,
    headerHeight = _ref168$2.headerHeight,
    fixedHeaderHeight = _ref168$2.fixedHeaderHeight,
    fixedFooterHeight = _ref168$2.fixedFooterHeight,
    scrollingInProgress = _ref168$2.scrollingInProgress,
    scrollToIndex = _ref168[2].scrollToIndex;
  var scrollIntoView = stream();
  connect(pipe(scrollIntoView, withLatestFrom(sizes, viewportHeight, totalCount, headerHeight, fixedHeaderHeight, fixedFooterHeight, scrollTop), withLatestFrom(gap), map(function (_ref169) {
    var _ref170 = _slicedToArray(_ref169, 2),
      _ref170$ = _slicedToArray(_ref170[0], 8),
      viewLocation = _ref170$[0],
      sizes2 = _ref170$[1],
      viewportHeight2 = _ref170$[2],
      totalCount2 = _ref170$[3],
      headerHeight2 = _ref170$[4],
      fixedHeaderHeight2 = _ref170$[5],
      fixedFooterHeight2 = _ref170$[6],
      scrollTop2 = _ref170$[7],
      gap2 = _ref170[1];
    var done = viewLocation.done,
      behavior = viewLocation.behavior,
      align = viewLocation.align,
      _viewLocation$calcula = viewLocation.calculateViewLocation,
      calculateViewLocation = _viewLocation$calcula === void 0 ? defaultCalculateViewLocation : _viewLocation$calcula,
      rest = _objectWithoutProperties(viewLocation, _excluded3);
    var actualIndex = originalIndexFromLocation(viewLocation, sizes2, totalCount2 - 1);
    var itemTop2 = offsetOf(actualIndex, sizes2.offsetTree, gap2) + headerHeight2 + fixedHeaderHeight2;
    var itemBottom = itemTop2 + findMaxKeyValue(sizes2.sizeTree, actualIndex)[1];
    var viewportTop = scrollTop2 + fixedHeaderHeight2;
    var viewportBottom = scrollTop2 + viewportHeight2 - fixedFooterHeight2;
    var location = calculateViewLocation({
      itemTop: itemTop2,
      itemBottom: itemBottom,
      viewportTop: viewportTop,
      viewportBottom: viewportBottom,
      locationParams: _objectSpread({
        behavior: behavior,
        align: align
      }, rest)
    });
    if (location) {
      done && handleNext(pipe(scrollingInProgress, filter(function (value) {
        return value === false;
      }),
      // skips the initial publish of false, and the cleanup call.
      // but if scrollingInProgress is true, we skip the initial publish.
      skip(getValue(scrollingInProgress) ? 1 : 2)), done);
    } else {
      done && done();
    }
    return location;
  }), filter(function (value) {
    return value !== null;
  })), scrollToIndex);
  return {
    scrollIntoView: scrollIntoView
  };
}, tup(sizeSystem, domIOSystem, scrollToIndexSystem, listStateSystem, loggerSystem), {
  singleton: true
});
var stateLoadSystem = system(function (_ref171) {
  var _ref172 = _slicedToArray(_ref171, 5),
    _ref172$ = _ref172[0],
    sizes = _ref172$.sizes,
    sizeRanges = _ref172$.sizeRanges,
    scrollTop = _ref172[1].scrollTop,
    initialTopMostItemIndex = _ref172[2].initialTopMostItemIndex,
    didMount = _ref172[3].didMount,
    _ref172$2 = _ref172[4],
    useWindowScroll = _ref172$2.useWindowScroll,
    windowScrollContainerState = _ref172$2.windowScrollContainerState,
    windowViewportRect = _ref172$2.windowViewportRect;
  var getState = stream();
  var restoreStateFrom = statefulStream(void 0);
  var statefulWindowScrollContainerState = statefulStream(null);
  var statefulWindowViewportRect = statefulStream(null);
  connect(windowScrollContainerState, statefulWindowScrollContainerState);
  connect(windowViewportRect, statefulWindowViewportRect);
  subscribe(pipe(getState, withLatestFrom(sizes, scrollTop, useWindowScroll, statefulWindowScrollContainerState, statefulWindowViewportRect)), function (_ref173) {
    var _ref174 = _slicedToArray(_ref173, 6),
      callback = _ref174[0],
      sizes2 = _ref174[1],
      scrollTop2 = _ref174[2],
      useWindowScroll2 = _ref174[3],
      windowScrollContainerState2 = _ref174[4],
      windowViewportRect2 = _ref174[5];
    var ranges = sizeTreeToRanges(sizes2.sizeTree);
    if (useWindowScroll2 && windowScrollContainerState2 !== null && windowViewportRect2 !== null) {
      scrollTop2 = windowScrollContainerState2.scrollTop - windowViewportRect2.offsetTop;
    }
    callback({
      ranges: ranges,
      scrollTop: scrollTop2
    });
  });
  connect(pipe(restoreStateFrom, filter(isDefined), map(locationFromSnapshot)), initialTopMostItemIndex);
  connect(pipe(didMount, withLatestFrom(restoreStateFrom), filter(function (_ref175) {
    var _ref176 = _slicedToArray(_ref175, 2),
      state = _ref176[1];
    return state !== void 0;
  }), distinctUntilChanged(), map(function (_ref177) {
    var _ref178 = _slicedToArray(_ref177, 2),
      snapshot = _ref178[1];
    return snapshot.ranges;
  })), sizeRanges);
  return {
    getState: getState,
    restoreStateFrom: restoreStateFrom
  };
}, tup(sizeSystem, domIOSystem, initialTopMostItemIndexSystem, propsReadySystem, windowScrollerSystem));
function locationFromSnapshot(snapshot) {
  return {
    offset: snapshot.scrollTop,
    index: 0,
    align: "start"
  };
}
var featureGroup1System = system(function (_ref179) {
  var _ref180 = _slicedToArray(_ref179, 10),
    sizeRange = _ref180[0],
    initialItemCount = _ref180[1],
    propsReady = _ref180[2],
    scrollSeek = _ref180[3],
    totalListHeight = _ref180[4],
    initialScrollTopSystem2 = _ref180[5],
    alignToBottom = _ref180[6],
    windowScroller = _ref180[7],
    scrollIntoView = _ref180[8],
    logger = _ref180[9];
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, sizeRange), initialItemCount), propsReady), scrollSeek), totalListHeight), initialScrollTopSystem2), alignToBottom), windowScroller), scrollIntoView), logger);
}, tup(sizeRangeSystem, initialItemCountSystem, propsReadySystem, scrollSeekSystem, totalListHeightSystem, initialScrollTopSystem, alignToBottomSystem, windowScrollerSystem, scrollIntoViewSystem, loggerSystem));
var listSystem = system(function (_ref181) {
  var _ref182 = _slicedToArray(_ref181, 11),
    _ref182$ = _ref182[0],
    totalCount = _ref182$.totalCount,
    sizeRanges = _ref182$.sizeRanges,
    fixedItemSize = _ref182$.fixedItemSize,
    defaultItemSize = _ref182$.defaultItemSize,
    trackItemSizes = _ref182$.trackItemSizes,
    itemSize = _ref182$.itemSize,
    data = _ref182$.data,
    firstItemIndex = _ref182$.firstItemIndex,
    groupIndices = _ref182$.groupIndices,
    statefulTotalCount = _ref182$.statefulTotalCount,
    gap = _ref182$.gap,
    sizes = _ref182$.sizes,
    _ref182$2 = _ref182[1],
    initialTopMostItemIndex = _ref182$2.initialTopMostItemIndex,
    scrolledToInitialItem = _ref182$2.scrolledToInitialItem,
    domIO = _ref182[2],
    stateLoad = _ref182[3],
    followOutput = _ref182[4],
    _ref182$3 = _ref182[5],
    listState = _ref182$3.listState,
    topItemsIndexes = _ref182$3.topItemsIndexes,
    flags = _objectWithoutProperties(_ref182$3, _excluded4),
    scrollToIndex = _ref182[6].scrollToIndex,
    _ = _ref182[7],
    topItemCount = _ref182[8].topItemCount,
    groupCounts = _ref182[9].groupCounts,
    featureGroup1 = _ref182[10];
  connect(flags.rangeChanged, featureGroup1.scrollSeekRangeChanged);
  connect(pipe(featureGroup1.windowViewportRect, map(function (value) {
    return value.visibleHeight;
  })), domIO.viewportHeight);
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
    // input
    totalCount: totalCount,
    data: data,
    firstItemIndex: firstItemIndex,
    sizeRanges: sizeRanges,
    initialTopMostItemIndex: initialTopMostItemIndex,
    scrolledToInitialItem: scrolledToInitialItem,
    topItemsIndexes: topItemsIndexes,
    topItemCount: topItemCount,
    groupCounts: groupCounts,
    fixedItemHeight: fixedItemSize,
    defaultItemHeight: defaultItemSize,
    gap: gap
  }, followOutput), {}, {
    // output
    statefulTotalCount: statefulTotalCount,
    listState: listState,
    scrollToIndex: scrollToIndex,
    trackItemSizes: trackItemSizes,
    itemSize: itemSize,
    groupIndices: groupIndices
  }, flags), featureGroup1), domIO), {}, {
    sizes: sizes
  }, stateLoad);
}, tup(sizeSystem, initialTopMostItemIndexSystem, domIOSystem, stateLoadSystem, followOutputSystem, listStateSystem, scrollToIndexSystem, upwardScrollFixSystem, topItemCountSystem, groupedListSystem, featureGroup1System));
var WEBKIT_STICKY = "-webkit-sticky";
var STICKY = "sticky";
var positionStickyCssValue = simpleMemoize(function () {
  if (typeof document === "undefined") {
    return STICKY;
  }
  var node = document.createElement("div");
  node.style.position = WEBKIT_STICKY;
  return node.style.position === WEBKIT_STICKY ? WEBKIT_STICKY : STICKY;
});
function useWindowViewportRectRef(callback, customScrollParent) {
  var viewportInfo = React.useRef(null);
  var calculateInfo = React.useCallback(function (element) {
    if (element === null || !element.offsetParent) {
      return;
    }
    var rect = element.getBoundingClientRect();
    var visibleWidth = rect.width;
    var visibleHeight, offsetTop;
    if (customScrollParent) {
      var customScrollParentRect = customScrollParent.getBoundingClientRect();
      var deltaTop = rect.top - customScrollParentRect.top;
      visibleHeight = customScrollParentRect.height - Math.max(0, deltaTop);
      offsetTop = deltaTop + customScrollParent.scrollTop;
    } else {
      visibleHeight = window.innerHeight - Math.max(0, rect.top);
      offsetTop = rect.top + window.pageYOffset;
    }
    viewportInfo.current = {
      offsetTop: offsetTop,
      visibleHeight: visibleHeight,
      visibleWidth: visibleWidth
    };
    callback(viewportInfo.current);
  }, [callback, customScrollParent]);
  var _useSizeWithElRef = useSizeWithElRef(calculateInfo),
    callbackRef = _useSizeWithElRef.callbackRef,
    ref = _useSizeWithElRef.ref;
  var scrollAndResizeEventHandler = React.useCallback(function () {
    calculateInfo(ref.current);
  }, [calculateInfo, ref]);
  React.useEffect(function () {
    if (customScrollParent) {
      customScrollParent.addEventListener("scroll", scrollAndResizeEventHandler);
      var observer = new ResizeObserver(scrollAndResizeEventHandler);
      observer.observe(customScrollParent);
      return function () {
        customScrollParent.removeEventListener("scroll", scrollAndResizeEventHandler);
        observer.unobserve(customScrollParent);
      };
    } else {
      window.addEventListener("scroll", scrollAndResizeEventHandler);
      window.addEventListener("resize", scrollAndResizeEventHandler);
      return function () {
        window.removeEventListener("scroll", scrollAndResizeEventHandler);
        window.removeEventListener("resize", scrollAndResizeEventHandler);
      };
    }
  }, [scrollAndResizeEventHandler, customScrollParent]);
  return callbackRef;
}
var VirtuosoMockContext = /*#__PURE__*/React.createContext(void 0);
var VirtuosoGridMockContext = /*#__PURE__*/React.createContext(void 0);
function identity(value) {
  return value;
}
var listComponentPropsSystem = /* @__PURE__ */system(function () {
  var itemContent = statefulStream(function (index) {
    return "Item ".concat(index);
  });
  var context = statefulStream(null);
  var groupContent = statefulStream(function (index) {
    return "Group ".concat(index);
  });
  var components = statefulStream({});
  var computeItemKey = statefulStream(identity);
  var headerFooterTag = statefulStream("div");
  var scrollerRef = statefulStream(noop);
  var distinctProp = function distinctProp(propName) {
    var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return statefulStreamFromEmitter(pipe(components, map(function (components2) {
      return components2[propName];
    }), distinctUntilChanged()), defaultValue);
  };
  return {
    context: context,
    itemContent: itemContent,
    groupContent: groupContent,
    components: components,
    computeItemKey: computeItemKey,
    headerFooterTag: headerFooterTag,
    scrollerRef: scrollerRef,
    FooterComponent: distinctProp("Footer"),
    HeaderComponent: distinctProp("Header"),
    TopItemListComponent: distinctProp("TopItemList"),
    ListComponent: distinctProp("List", "div"),
    ItemComponent: distinctProp("Item", "div"),
    GroupComponent: distinctProp("Group", "div"),
    ScrollerComponent: distinctProp("Scroller", "div"),
    EmptyPlaceholder: distinctProp("EmptyPlaceholder"),
    ScrollSeekPlaceholder: distinctProp("ScrollSeekPlaceholder")
  };
});
var combinedSystem$2 = /* @__PURE__ */system(function (_ref183) {
  var _ref184 = _slicedToArray(_ref183, 2),
    listSystem2 = _ref184[0],
    propsSystem = _ref184[1];
  return _objectSpread(_objectSpread({}, listSystem2), propsSystem);
}, tup(listSystem, listComponentPropsSystem));
var DefaultScrollSeekPlaceholder$1 = function DefaultScrollSeekPlaceholder$1(_ref185) {
  var height = _ref185.height;
  return /* @__PURE__ */React.createElement("div", {
    style: {
      height: height
    }
  });
};
var GROUP_STYLE = {
  position: positionStickyCssValue(),
  zIndex: 1,
  overflowAnchor: "none"
};
var ITEM_STYLE$1 = {
  overflowAnchor: "none"
};
var Items$1 = /* @__PURE__ */React.memo(function VirtuosoItems(_ref186) {
  var _ref186$showTopList = _ref186.showTopList,
    showTopList = _ref186$showTopList === void 0 ? false : _ref186$showTopList;
  var listState = useEmitterValue$2("listState");
  var sizeRanges = usePublisher$2("sizeRanges");
  var useWindowScroll = useEmitterValue$2("useWindowScroll");
  var customScrollParent = useEmitterValue$2("customScrollParent");
  var windowScrollContainerStateCallback = usePublisher$2("windowScrollContainerState");
  var _scrollContainerStateCallback = usePublisher$2("scrollContainerState");
  var scrollContainerStateCallback = customScrollParent || useWindowScroll ? windowScrollContainerStateCallback : _scrollContainerStateCallback;
  var itemContent = useEmitterValue$2("itemContent");
  var context = useEmitterValue$2("context");
  var groupContent = useEmitterValue$2("groupContent");
  var trackItemSizes = useEmitterValue$2("trackItemSizes");
  var itemSize = useEmitterValue$2("itemSize");
  var log = useEmitterValue$2("log");
  var listGap = usePublisher$2("gap");
  var _useChangedListConten = useChangedListContentsSizes(sizeRanges, itemSize, trackItemSizes, showTopList ? noop : scrollContainerStateCallback, log, listGap, customScrollParent),
    callbackRef = _useChangedListConten.callbackRef;
  var _React$useState7 = React.useState(0),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    deviation = _React$useState8[0],
    setDeviation = _React$useState8[1];
  useEmitter$2("deviation", function (value) {
    if (deviation !== value) {
      setDeviation(value);
    }
  });
  var EmptyPlaceholder = useEmitterValue$2("EmptyPlaceholder");
  var ScrollSeekPlaceholder = useEmitterValue$2("ScrollSeekPlaceholder") || DefaultScrollSeekPlaceholder$1;
  var ListComponent = useEmitterValue$2("ListComponent");
  var ItemComponent = useEmitterValue$2("ItemComponent");
  var GroupComponent = useEmitterValue$2("GroupComponent");
  var computeItemKey = useEmitterValue$2("computeItemKey");
  var isSeeking = useEmitterValue$2("isSeeking");
  var hasGroups2 = useEmitterValue$2("groupIndices").length > 0;
  var paddingTopAddition = useEmitterValue$2("paddingTopAddition");
  var scrolledToInitialItem = useEmitterValue$2("scrolledToInitialItem");
  var containerStyle = showTopList ? {} : _objectSpread({
    boxSizing: "border-box",
    paddingTop: listState.offsetTop + paddingTopAddition,
    paddingBottom: listState.offsetBottom,
    marginTop: deviation
  }, scrolledToInitialItem ? {} : {
    visibility: "hidden"
  });
  if (!showTopList && listState.totalCount === 0 && EmptyPlaceholder) {
    return /*#__PURE__*/React.createElement(EmptyPlaceholder, contextPropIfNotDomElement(EmptyPlaceholder, context));
  }
  return /*#__PURE__*/React.createElement(ListComponent, _objectSpread(_objectSpread({}, contextPropIfNotDomElement(ListComponent, context)), {}, {
    ref: callbackRef,
    style: containerStyle,
    "data-test-id": showTopList ? "virtuoso-top-item-list" : "virtuoso-item-list"
  }), (showTopList ? listState.topItems : listState.items).map(function (item) {
    var index = item.originalIndex;
    var key = computeItemKey(index + listState.firstItemIndex, item.data, context);
    if (isSeeking) {
      return /*#__PURE__*/React.createElement(ScrollSeekPlaceholder, _objectSpread(_objectSpread({}, contextPropIfNotDomElement(ScrollSeekPlaceholder, context)), {}, {
        key: key,
        index: item.index,
        height: item.size,
        type: item.type || "item"
      }, item.type === "group" ? {} : {
        groupIndex: item.groupIndex
      }));
    }
    if (item.type === "group") {
      return /*#__PURE__*/React.createElement(GroupComponent, _objectSpread(_objectSpread({}, contextPropIfNotDomElement(GroupComponent, context)), {}, {
        key: key,
        "data-index": index,
        "data-known-size": item.size,
        "data-item-index": item.index,
        style: GROUP_STYLE
      }), groupContent(item.index, context));
    } else {
      return /*#__PURE__*/React.createElement(ItemComponent, _objectSpread(_objectSpread(_objectSpread({}, contextPropIfNotDomElement(ItemComponent, context)), itemPropIfNotDomElement(ItemComponent, item.data)), {}, {
        key: key,
        "data-index": index,
        "data-known-size": item.size,
        "data-item-index": item.index,
        "data-item-group-index": item.groupIndex,
        style: ITEM_STYLE$1
      }), hasGroups2 ? itemContent(item.index, item.groupIndex, item.data, context) : itemContent(item.index, item.data, context));
    }
  }));
});
var scrollerStyle = {
  height: "100%",
  outline: "none",
  overflowY: "auto",
  position: "relative",
  WebkitOverflowScrolling: "touch"
};
var viewportStyle = {
  width: "100%",
  height: "100%",
  position: "absolute",
  top: 0
};
var topItemListStyle = {
  width: "100%",
  position: positionStickyCssValue(),
  top: 0,
  zIndex: 1
};
function contextPropIfNotDomElement(element, context) {
  if (typeof element === "string") {
    return void 0;
  }
  return {
    context: context
  };
}
function itemPropIfNotDomElement(element, item) {
  return {
    item: typeof element === "string" ? void 0 : item
  };
}
var Header$1 = /* @__PURE__ */React.memo(function VirtuosoHeader() {
  var Header2 = useEmitterValue$2("HeaderComponent");
  var headerHeight = usePublisher$2("headerHeight");
  var headerFooterTag = useEmitterValue$2("headerFooterTag");
  var ref = useSize(function (el) {
    return headerHeight(correctItemSize(el, "height"));
  });
  var context = useEmitterValue$2("context");
  return Header2 ? /*#__PURE__*/React.createElement(headerFooterTag, {
    ref: ref
  }, /*#__PURE__*/React.createElement(Header2, contextPropIfNotDomElement(Header2, context))) : null;
});
var Footer$1 = /* @__PURE__ */React.memo(function VirtuosoFooter() {
  var Footer2 = useEmitterValue$2("FooterComponent");
  var footerHeight = usePublisher$2("footerHeight");
  var headerFooterTag = useEmitterValue$2("headerFooterTag");
  var ref = useSize(function (el) {
    return footerHeight(correctItemSize(el, "height"));
  });
  var context = useEmitterValue$2("context");
  return Footer2 ? /*#__PURE__*/React.createElement(headerFooterTag, {
    ref: ref
  }, /*#__PURE__*/React.createElement(Footer2, contextPropIfNotDomElement(Footer2, context))) : null;
});
function buildScroller(_ref187) {
  var usePublisher2 = _ref187.usePublisher,
    useEmitter2 = _ref187.useEmitter,
    useEmitterValue2 = _ref187.useEmitterValue;
  var Scroller2 = /*#__PURE__*/React.memo(function VirtuosoScroller(_ref188) {
    var style = _ref188.style,
      children = _ref188.children,
      props = _objectWithoutProperties(_ref188, _excluded5);
    var scrollContainerStateCallback = usePublisher2("scrollContainerState");
    var ScrollerComponent = useEmitterValue2("ScrollerComponent");
    var smoothScrollTargetReached = usePublisher2("smoothScrollTargetReached");
    var scrollerRefCallback = useEmitterValue2("scrollerRef");
    var context = useEmitterValue2("context");
    var _useScrollTop = useScrollTop(scrollContainerStateCallback, smoothScrollTargetReached, ScrollerComponent, scrollerRefCallback),
      scrollerRef = _useScrollTop.scrollerRef,
      scrollByCallback = _useScrollTop.scrollByCallback,
      scrollToCallback = _useScrollTop.scrollToCallback;
    useEmitter2("scrollTo", scrollToCallback);
    useEmitter2("scrollBy", scrollByCallback);
    return /*#__PURE__*/React.createElement(ScrollerComponent, _objectSpread(_objectSpread({
      ref: scrollerRef,
      style: _objectSpread(_objectSpread({}, scrollerStyle), style),
      "data-test-id": "virtuoso-scroller",
      "data-virtuoso-scroller": true,
      tabIndex: 0
    }, props), contextPropIfNotDomElement(ScrollerComponent, context)), children);
  });
  return Scroller2;
}
function buildWindowScroller(_ref189) {
  var usePublisher2 = _ref189.usePublisher,
    useEmitter2 = _ref189.useEmitter,
    useEmitterValue2 = _ref189.useEmitterValue;
  var Scroller2 = /*#__PURE__*/React.memo(function VirtuosoWindowScroller(_ref190) {
    var style = _ref190.style,
      children = _ref190.children,
      props = _objectWithoutProperties(_ref190, _excluded6);
    var scrollContainerStateCallback = usePublisher2("windowScrollContainerState");
    var ScrollerComponent = useEmitterValue2("ScrollerComponent");
    var smoothScrollTargetReached = usePublisher2("smoothScrollTargetReached");
    var totalListHeight = useEmitterValue2("totalListHeight");
    var deviation = useEmitterValue2("deviation");
    var customScrollParent = useEmitterValue2("customScrollParent");
    var context = useEmitterValue2("context");
    var _useScrollTop2 = useScrollTop(scrollContainerStateCallback, smoothScrollTargetReached, ScrollerComponent, noop, customScrollParent),
      scrollerRef = _useScrollTop2.scrollerRef,
      scrollByCallback = _useScrollTop2.scrollByCallback,
      scrollToCallback = _useScrollTop2.scrollToCallback;
    useIsomorphicLayoutEffect$1(function () {
      scrollerRef.current = customScrollParent ? customScrollParent : window;
      return function () {
        scrollerRef.current = null;
      };
    }, [scrollerRef, customScrollParent]);
    useEmitter2("windowScrollTo", scrollToCallback);
    useEmitter2("scrollBy", scrollByCallback);
    return /*#__PURE__*/React.createElement(ScrollerComponent, _objectSpread(_objectSpread({
      style: _objectSpread(_objectSpread({
        position: "relative"
      }, style), totalListHeight !== 0 ? {
        height: totalListHeight + deviation
      } : {}),
      "data-virtuoso-scroller": true
    }, props), contextPropIfNotDomElement(ScrollerComponent, context)), children);
  });
  return Scroller2;
}
var Viewport$2 = function Viewport$2(_ref191) {
  var children = _ref191.children;
  var ctx = React.useContext(VirtuosoMockContext);
  var viewportHeight = usePublisher$2("viewportHeight");
  var fixedItemHeight = usePublisher$2("fixedItemHeight");
  var viewportRef = useSize(compose(viewportHeight, function (el) {
    return correctItemSize(el, "height");
  }));
  React.useEffect(function () {
    if (ctx) {
      viewportHeight(ctx.viewportHeight);
      fixedItemHeight(ctx.itemHeight);
    }
  }, [ctx, viewportHeight, fixedItemHeight]);
  return /* @__PURE__ */React.createElement("div", {
    style: viewportStyle,
    ref: viewportRef,
    "data-viewport-type": "element"
  }, children);
};
var WindowViewport$2 = function WindowViewport$2(_ref192) {
  var children = _ref192.children;
  var ctx = React.useContext(VirtuosoMockContext);
  var windowViewportRect = usePublisher$2("windowViewportRect");
  var fixedItemHeight = usePublisher$2("fixedItemHeight");
  var customScrollParent = useEmitterValue$2("customScrollParent");
  var viewportRef = useWindowViewportRectRef(windowViewportRect, customScrollParent);
  React.useEffect(function () {
    if (ctx) {
      fixedItemHeight(ctx.itemHeight);
      windowViewportRect({
        offsetTop: 0,
        visibleHeight: ctx.viewportHeight,
        visibleWidth: 100
      });
    }
  }, [ctx, windowViewportRect, fixedItemHeight]);
  return /* @__PURE__ */React.createElement("div", {
    ref: viewportRef,
    style: viewportStyle,
    "data-viewport-type": "window"
  }, children);
};
var TopItemListContainer = function TopItemListContainer(_ref193) {
  var children = _ref193.children;
  var TopItemList = useEmitterValue$2("TopItemListComponent");
  var headerHeight = useEmitterValue$2("headerHeight");
  var style = _objectSpread(_objectSpread({}, topItemListStyle), {}, {
    marginTop: "".concat(headerHeight, "px")
  });
  var context = useEmitterValue$2("context");
  return /*#__PURE__*/React.createElement(TopItemList || "div", {
    style: style,
    context: context
  }, children);
};
var ListRoot = /* @__PURE__ */React.memo(function VirtuosoRoot(props) {
  var useWindowScroll = useEmitterValue$2("useWindowScroll");
  var showTopList = useEmitterValue$2("topItemsIndexes").length > 0;
  var customScrollParent = useEmitterValue$2("customScrollParent");
  var TheScroller = customScrollParent || useWindowScroll ? WindowScroller$2 : Scroller$2;
  var TheViewport = customScrollParent || useWindowScroll ? WindowViewport$2 : Viewport$2;
  return /* @__PURE__ */React.createElement(TheScroller, _objectSpread({}, props), showTopList && /* @__PURE__ */React.createElement(TopItemListContainer, null, /* @__PURE__ */React.createElement(Items$1, {
    showTopList: true
  })), /* @__PURE__ */React.createElement(TheViewport, null, /* @__PURE__ */React.createElement(Header$1, null), /* @__PURE__ */React.createElement(Items$1, null), /* @__PURE__ */React.createElement(Footer$1, null)));
});
var _systemToComponent = /* @__PURE__ */systemToComponent(combinedSystem$2, {
    required: {},
    optional: {
      restoreStateFrom: "restoreStateFrom",
      context: "context",
      followOutput: "followOutput",
      itemContent: "itemContent",
      groupContent: "groupContent",
      overscan: "overscan",
      increaseViewportBy: "increaseViewportBy",
      totalCount: "totalCount",
      groupCounts: "groupCounts",
      topItemCount: "topItemCount",
      firstItemIndex: "firstItemIndex",
      initialTopMostItemIndex: "initialTopMostItemIndex",
      components: "components",
      atBottomThreshold: "atBottomThreshold",
      atTopThreshold: "atTopThreshold",
      computeItemKey: "computeItemKey",
      defaultItemHeight: "defaultItemHeight",
      fixedItemHeight: "fixedItemHeight",
      itemSize: "itemSize",
      scrollSeekConfiguration: "scrollSeekConfiguration",
      headerFooterTag: "headerFooterTag",
      data: "data",
      initialItemCount: "initialItemCount",
      initialScrollTop: "initialScrollTop",
      alignToBottom: "alignToBottom",
      useWindowScroll: "useWindowScroll",
      customScrollParent: "customScrollParent",
      scrollerRef: "scrollerRef",
      logLevel: "logLevel"
    },
    methods: {
      scrollToIndex: "scrollToIndex",
      scrollIntoView: "scrollIntoView",
      scrollTo: "scrollTo",
      scrollBy: "scrollBy",
      autoscrollToBottom: "autoscrollToBottom",
      getState: "getState"
    },
    events: {
      isScrolling: "isScrolling",
      endReached: "endReached",
      startReached: "startReached",
      rangeChanged: "rangeChanged",
      atBottomStateChange: "atBottomStateChange",
      atTopStateChange: "atTopStateChange",
      totalListHeightChanged: "totalListHeightChanged",
      itemsRendered: "itemsRendered",
      groupIndices: "groupIndices"
    }
  }, ListRoot),
  List = _systemToComponent.Component,
  usePublisher$2 = _systemToComponent.usePublisher,
  useEmitterValue$2 = _systemToComponent.useEmitterValue,
  useEmitter$2 = _systemToComponent.useEmitter;
var Scroller$2 = /* @__PURE__ */buildScroller({
  usePublisher: usePublisher$2,
  useEmitterValue: useEmitterValue$2,
  useEmitter: useEmitter$2
});
var WindowScroller$2 = /* @__PURE__ */buildWindowScroller({
  usePublisher: usePublisher$2,
  useEmitterValue: useEmitterValue$2,
  useEmitter: useEmitter$2
});
var Virtuoso = List;
var GroupedVirtuoso = List;
var INITIAL_GRID_STATE = {
  items: [],
  offsetBottom: 0,
  offsetTop: 0,
  top: 0,
  bottom: 0,
  itemHeight: 0,
  itemWidth: 0
};
var PROBE_GRID_STATE = {
  items: [{
    index: 0
  }],
  offsetBottom: 0,
  offsetTop: 0,
  top: 0,
  bottom: 0,
  itemHeight: 0,
  itemWidth: 0
};
var round = Math.round,
  ceil = Math.ceil,
  floor = Math.floor,
  min = Math.min,
  max = Math.max;
function buildProbeGridState(items) {
  return _objectSpread(_objectSpread({}, PROBE_GRID_STATE), {}, {
    items: items
  });
}
function buildItems(startIndex, endIndex, data) {
  return Array.from({
    length: endIndex - startIndex + 1
  }).map(function (_, i) {
    var dataItem = data === null ? null : data[i + startIndex];
    return {
      index: i + startIndex,
      data: dataItem
    };
  });
}
function gapComparator(prev, next) {
  return prev && prev.column === next.column && prev.row === next.row;
}
function dimensionComparator(prev, next) {
  return prev && prev.width === next.width && prev.height === next.height;
}
var gridSystem = /* @__PURE__ */system(function (_ref194) {
  var _ref195 = _slicedToArray(_ref194, 7),
    _ref195$ = _ref195[0],
    overscan = _ref195$.overscan,
    visibleRange = _ref195$.visibleRange,
    listBoundary = _ref195$.listBoundary,
    _ref195$2 = _ref195[1],
    scrollTop = _ref195$2.scrollTop,
    viewportHeight = _ref195$2.viewportHeight,
    scrollBy = _ref195$2.scrollBy,
    scrollTo = _ref195$2.scrollTo,
    smoothScrollTargetReached = _ref195$2.smoothScrollTargetReached,
    scrollContainerState = _ref195$2.scrollContainerState,
    footerHeight = _ref195$2.footerHeight,
    headerHeight = _ref195$2.headerHeight,
    stateFlags = _ref195[2],
    scrollSeek = _ref195[3],
    _ref195$3 = _ref195[4],
    propsReady = _ref195$3.propsReady,
    didMount = _ref195$3.didMount,
    _ref195$4 = _ref195[5],
    windowViewportRect = _ref195$4.windowViewportRect,
    useWindowScroll = _ref195$4.useWindowScroll,
    customScrollParent = _ref195$4.customScrollParent,
    windowScrollContainerState = _ref195$4.windowScrollContainerState,
    windowScrollTo = _ref195$4.windowScrollTo,
    log = _ref195[6];
  var totalCount = statefulStream(0);
  var initialItemCount = statefulStream(0);
  var gridState = statefulStream(INITIAL_GRID_STATE);
  var viewportDimensions = statefulStream({
    height: 0,
    width: 0
  });
  var itemDimensions = statefulStream({
    height: 0,
    width: 0
  });
  var scrollToIndex = stream();
  var scrollHeight = stream();
  var deviation = statefulStream(0);
  var data = statefulStream(null);
  var gap = statefulStream({
    row: 0,
    column: 0
  });
  var stateChanged = stream();
  var restoreStateFrom = stream();
  var stateRestoreInProgress = statefulStream(false);
  var initialTopMostItemIndex = statefulStream(0);
  var scrolledToInitialItem = statefulStream(true);
  var scrollScheduled = statefulStream(false);
  subscribe(pipe(didMount, withLatestFrom(initialTopMostItemIndex), filter(function (_ref196) {
    var _ref197 = _slicedToArray(_ref196, 2),
      _ = _ref197[0],
      location = _ref197[1];
    return !!location;
  })), function () {
    publish(scrolledToInitialItem, false);
    publish(initialItemCount, 0);
  });
  subscribe(pipe(combineLatest(didMount, scrolledToInitialItem, itemDimensions, viewportDimensions, initialTopMostItemIndex, scrollScheduled), filter(function (_ref198) {
    var _ref199 = _slicedToArray(_ref198, 6),
      didMount2 = _ref199[0],
      scrolledToInitialItem2 = _ref199[1],
      itemDimensions2 = _ref199[2],
      viewportDimensions2 = _ref199[3],
      scrollScheduled2 = _ref199[5];
    return didMount2 && !scrolledToInitialItem2 && itemDimensions2.height !== 0 && viewportDimensions2.height !== 0 && !scrollScheduled2;
  })), function (_ref200) {
    var _ref201 = _slicedToArray(_ref200, 5),
      initialTopMostItemIndex2 = _ref201[4];
    publish(scrollScheduled, true);
    skipFrames(1, function () {
      publish(scrollToIndex, initialTopMostItemIndex2);
    });
    handleNext(pipe(scrollTop), function () {
      publish(listBoundary, [0, 0]);
      publish(scrolledToInitialItem, true);
    });
  });
  connect(pipe(restoreStateFrom, filter(function (value) {
    return value !== void 0 && value !== null && value.scrollTop > 0;
  }), mapTo(0)), initialItemCount);
  subscribe(pipe(didMount, withLatestFrom(restoreStateFrom), filter(function (_ref202) {
    var _ref203 = _slicedToArray(_ref202, 2),
      snapshot = _ref203[1];
    return snapshot !== void 0 && snapshot !== null;
  })), function (_ref204) {
    var _ref205 = _slicedToArray(_ref204, 2),
      snapshot = _ref205[1];
    if (!snapshot) {
      return;
    }
    publish(viewportDimensions, snapshot.viewport), publish(itemDimensions, snapshot == null ? void 0 : snapshot.item);
    publish(gap, snapshot.gap);
    if (snapshot.scrollTop > 0) {
      publish(stateRestoreInProgress, true);
      handleNext(pipe(scrollTop, skip(1)), function (_value) {
        publish(stateRestoreInProgress, false);
      });
      publish(scrollTo, {
        top: snapshot.scrollTop
      });
    }
  });
  connect(pipe(viewportDimensions, map(function (_ref206) {
    var height = _ref206.height;
    return height;
  })), viewportHeight);
  connect(pipe(combineLatest(duc(viewportDimensions, dimensionComparator), duc(itemDimensions, dimensionComparator), duc(gap, function (prev, next) {
    return prev && prev.column === next.column && prev.row === next.row;
  }), duc(scrollTop)), map(function (_ref207) {
    var _ref208 = _slicedToArray(_ref207, 4),
      viewport = _ref208[0],
      item = _ref208[1],
      gap2 = _ref208[2],
      scrollTop2 = _ref208[3];
    return {
      viewport: viewport,
      item: item,
      gap: gap2,
      scrollTop: scrollTop2
    };
  })), stateChanged);
  connect(pipe(combineLatest(duc(totalCount), visibleRange, duc(gap, gapComparator), duc(itemDimensions, dimensionComparator), duc(viewportDimensions, dimensionComparator), duc(data), duc(initialItemCount), duc(stateRestoreInProgress), duc(scrolledToInitialItem), duc(initialTopMostItemIndex)), filter(function (_ref209) {
    var _ref210 = _slicedToArray(_ref209, 8),
      stateRestoreInProgress2 = _ref210[7];
    return !stateRestoreInProgress2;
  }), map(function (_ref211) {
    var _ref212 = _slicedToArray(_ref211, 10),
      totalCount2 = _ref212[0],
      _ref212$ = _slicedToArray(_ref212[1], 2),
      startOffset = _ref212$[0],
      endOffset = _ref212$[1],
      gap2 = _ref212[2],
      item = _ref212[3],
      viewport = _ref212[4],
      data2 = _ref212[5],
      initialItemCount2 = _ref212[6],
      scrolledToInitialItem2 = _ref212[8],
      initialTopMostItemIndex2 = _ref212[9];
    var rowGap = gap2.row,
      columnGap = gap2.column;
    var itemHeight = item.height,
      itemWidth = item.width;
    var viewportWidth = viewport.width;
    if (initialItemCount2 === 0 && (totalCount2 === 0 || viewportWidth === 0)) {
      return INITIAL_GRID_STATE;
    }
    if (itemWidth === 0) {
      var startIndex2 = getInitialTopMostItemIndexNumber(initialTopMostItemIndex2, totalCount2);
      var endIndex2 = startIndex2 === 0 ? Math.max(initialItemCount2 - 1, 0) : startIndex2;
      return buildProbeGridState(buildItems(startIndex2, endIndex2, data2));
    }
    var perRow = itemsPerRow(viewportWidth, itemWidth, columnGap);
    var startIndex;
    var endIndex;
    if (!scrolledToInitialItem2) {
      startIndex = 0;
      endIndex = -1;
    } else if (startOffset === 0 && endOffset === 0 && initialItemCount2 > 0) {
      startIndex = 0;
      endIndex = initialItemCount2 - 1;
    } else {
      startIndex = perRow * floor((startOffset + rowGap) / (itemHeight + rowGap));
      endIndex = perRow * ceil((endOffset + rowGap) / (itemHeight + rowGap)) - 1;
      endIndex = min(totalCount2 - 1, max(endIndex, perRow - 1));
      startIndex = min(endIndex, max(0, startIndex));
    }
    var items = buildItems(startIndex, endIndex, data2);
    var _gridLayout = gridLayout(viewport, gap2, item, items),
      top = _gridLayout.top,
      bottom = _gridLayout.bottom;
    var rowCount = ceil(totalCount2 / perRow);
    var totalHeight = rowCount * itemHeight + (rowCount - 1) * rowGap;
    var offsetBottom = totalHeight - bottom;
    return {
      items: items,
      offsetTop: top,
      offsetBottom: offsetBottom,
      top: top,
      bottom: bottom,
      itemHeight: itemHeight,
      itemWidth: itemWidth
    };
  })), gridState);
  connect(pipe(data, filter(function (data2) {
    return data2 !== null;
  }), map(function (data2) {
    return data2.length;
  })), totalCount);
  connect(pipe(combineLatest(viewportDimensions, itemDimensions, gridState, gap), filter(function (_ref213) {
    var _ref214 = _slicedToArray(_ref213, 3),
      viewportDimensions2 = _ref214[0],
      itemDimensions2 = _ref214[1],
      items = _ref214[2].items;
    return items.length > 0 && itemDimensions2.height !== 0 && viewportDimensions2.height !== 0;
  }), map(function (_ref215) {
    var _ref216 = _slicedToArray(_ref215, 4),
      viewportDimensions2 = _ref216[0],
      itemDimensions2 = _ref216[1],
      items = _ref216[2].items,
      gap2 = _ref216[3];
    var _gridLayout2 = gridLayout(viewportDimensions2, gap2, itemDimensions2, items),
      top = _gridLayout2.top,
      bottom = _gridLayout2.bottom;
    return [top, bottom];
  }), distinctUntilChanged(tupleComparator)), listBoundary);
  var hasScrolled = statefulStream(false);
  connect(pipe(scrollTop, withLatestFrom(hasScrolled), map(function (_ref217) {
    var _ref218 = _slicedToArray(_ref217, 2),
      scrollTop2 = _ref218[0],
      hasScrolled2 = _ref218[1];
    return hasScrolled2 || scrollTop2 !== 0;
  })), hasScrolled);
  var endReached = streamFromEmitter(pipe(duc(gridState), filter(function (_ref219) {
    var items = _ref219.items;
    return items.length > 0;
  }), withLatestFrom(totalCount, hasScrolled), filter(function (_ref220) {
    var _ref221 = _slicedToArray(_ref220, 3),
      items = _ref221[0].items,
      totalCount2 = _ref221[1],
      hasScrolled2 = _ref221[2];
    return hasScrolled2 && items[items.length - 1].index === totalCount2 - 1;
  }), map(function (_ref222) {
    var _ref223 = _slicedToArray(_ref222, 2),
      totalCount2 = _ref223[1];
    return totalCount2 - 1;
  }), distinctUntilChanged()));
  var startReached = streamFromEmitter(pipe(duc(gridState), filter(function (_ref224) {
    var items = _ref224.items;
    return items.length > 0 && items[0].index === 0;
  }),
  // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
  mapTo(0), distinctUntilChanged()));
  var rangeChanged = streamFromEmitter(pipe(duc(gridState), withLatestFrom(stateRestoreInProgress), filter(function (_ref225) {
    var _ref226 = _slicedToArray(_ref225, 2),
      items = _ref226[0].items,
      stateRestoreInProgress2 = _ref226[1];
    return items.length > 0 && !stateRestoreInProgress2;
  }), map(function (_ref227) {
    var _ref228 = _slicedToArray(_ref227, 1),
      items = _ref228[0].items;
    return {
      startIndex: items[0].index,
      endIndex: items[items.length - 1].index
    };
  }), distinctUntilChanged(rangeComparator), throttleTime(0)));
  connect(rangeChanged, scrollSeek.scrollSeekRangeChanged);
  connect(pipe(scrollToIndex, withLatestFrom(viewportDimensions, itemDimensions, totalCount, gap), map(function (_ref229) {
    var _ref230 = _slicedToArray(_ref229, 5),
      location = _ref230[0],
      viewportDimensions2 = _ref230[1],
      itemDimensions2 = _ref230[2],
      totalCount2 = _ref230[3],
      gap2 = _ref230[4];
    var normalLocation = normalizeIndexLocation(location);
    var align = normalLocation.align,
      behavior = normalLocation.behavior,
      offset = normalLocation.offset;
    var index = normalLocation.index;
    if (index === "LAST") {
      index = totalCount2 - 1;
    }
    index = max(0, index, min(totalCount2 - 1, index));
    var top = itemTop(viewportDimensions2, gap2, itemDimensions2, index);
    if (align === "end") {
      top = round(top - viewportDimensions2.height + itemDimensions2.height);
    } else if (align === "center") {
      top = round(top - viewportDimensions2.height / 2 + itemDimensions2.height / 2);
    }
    if (offset) {
      top += offset;
    }
    return {
      top: top,
      behavior: behavior
    };
  })), scrollTo);
  var totalListHeight = statefulStreamFromEmitter(pipe(gridState, map(function (gridState2) {
    return gridState2.offsetBottom + gridState2.bottom;
  })), 0);
  connect(pipe(windowViewportRect, map(function (viewportInfo) {
    return {
      width: viewportInfo.visibleWidth,
      height: viewportInfo.visibleHeight
    };
  })), viewportDimensions);
  return _objectSpread(_objectSpread(_objectSpread({
    // input
    data: data,
    totalCount: totalCount,
    viewportDimensions: viewportDimensions,
    itemDimensions: itemDimensions,
    scrollTop: scrollTop,
    scrollHeight: scrollHeight,
    overscan: overscan,
    scrollBy: scrollBy,
    scrollTo: scrollTo,
    scrollToIndex: scrollToIndex,
    smoothScrollTargetReached: smoothScrollTargetReached,
    windowViewportRect: windowViewportRect,
    windowScrollTo: windowScrollTo,
    useWindowScroll: useWindowScroll,
    customScrollParent: customScrollParent,
    windowScrollContainerState: windowScrollContainerState,
    deviation: deviation,
    scrollContainerState: scrollContainerState,
    footerHeight: footerHeight,
    headerHeight: headerHeight,
    initialItemCount: initialItemCount,
    gap: gap,
    restoreStateFrom: restoreStateFrom
  }, scrollSeek), {}, {
    initialTopMostItemIndex: initialTopMostItemIndex,
    // output
    gridState: gridState,
    totalListHeight: totalListHeight
  }, stateFlags), {}, {
    startReached: startReached,
    endReached: endReached,
    rangeChanged: rangeChanged,
    stateChanged: stateChanged,
    propsReady: propsReady,
    stateRestoreInProgress: stateRestoreInProgress
  }, log);
}, tup(sizeRangeSystem, domIOSystem, stateFlagsSystem, scrollSeekSystem, propsReadySystem, windowScrollerSystem, loggerSystem));
function gridLayout(viewport, gap, item, items) {
  var itemHeight = item.height;
  if (itemHeight === void 0 || items.length === 0) {
    return {
      top: 0,
      bottom: 0
    };
  }
  var top = itemTop(viewport, gap, item, items[0].index);
  var bottom = itemTop(viewport, gap, item, items[items.length - 1].index) + itemHeight;
  return {
    top: top,
    bottom: bottom
  };
}
function itemTop(viewport, gap, item, index) {
  var perRow = itemsPerRow(viewport.width, item.width, gap.column);
  var rowCount = floor(index / perRow);
  var top = rowCount * item.height + max(0, rowCount - 1) * gap.row;
  return top > 0 ? top + gap.row : top;
}
function itemsPerRow(viewportWidth, itemWidth, gap) {
  return max(1, floor((viewportWidth + gap) / (floor(itemWidth) + gap)));
}
var gridComponentPropsSystem = /* @__PURE__ */system(function () {
  var itemContent = statefulStream(function (index) {
    return "Item ".concat(index);
  });
  var components = statefulStream({});
  var context = statefulStream(null);
  var itemClassName = statefulStream("virtuoso-grid-item");
  var listClassName = statefulStream("virtuoso-grid-list");
  var computeItemKey = statefulStream(identity);
  var headerFooterTag = statefulStream("div");
  var scrollerRef = statefulStream(noop);
  var distinctProp = function distinctProp(propName) {
    var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return statefulStreamFromEmitter(pipe(components, map(function (components2) {
      return components2[propName];
    }), distinctUntilChanged()), defaultValue);
  };
  return {
    context: context,
    itemContent: itemContent,
    components: components,
    computeItemKey: computeItemKey,
    itemClassName: itemClassName,
    listClassName: listClassName,
    headerFooterTag: headerFooterTag,
    scrollerRef: scrollerRef,
    FooterComponent: distinctProp("Footer"),
    HeaderComponent: distinctProp("Header"),
    ListComponent: distinctProp("List", "div"),
    ItemComponent: distinctProp("Item", "div"),
    ScrollerComponent: distinctProp("Scroller", "div"),
    ScrollSeekPlaceholder: distinctProp("ScrollSeekPlaceholder", "div")
  };
});
var combinedSystem$1 = /* @__PURE__ */system(function (_ref231) {
  var _ref232 = _slicedToArray(_ref231, 2),
    gridSystem2 = _ref232[0],
    gridComponentPropsSystem2 = _ref232[1];
  return _objectSpread(_objectSpread({}, gridSystem2), gridComponentPropsSystem2);
}, tup(gridSystem, gridComponentPropsSystem));
var GridItems = /* @__PURE__ */React.memo(function GridItems2() {
  var gridState = useEmitterValue$1("gridState");
  var listClassName = useEmitterValue$1("listClassName");
  var itemClassName = useEmitterValue$1("itemClassName");
  var itemContent = useEmitterValue$1("itemContent");
  var computeItemKey = useEmitterValue$1("computeItemKey");
  var isSeeking = useEmitterValue$1("isSeeking");
  var scrollHeightCallback = usePublisher$1("scrollHeight");
  var ItemComponent = useEmitterValue$1("ItemComponent");
  var ListComponent = useEmitterValue$1("ListComponent");
  var ScrollSeekPlaceholder = useEmitterValue$1("ScrollSeekPlaceholder");
  var context = useEmitterValue$1("context");
  var itemDimensions = usePublisher$1("itemDimensions");
  var gridGap = usePublisher$1("gap");
  var log = useEmitterValue$1("log");
  var stateRestoreInProgress = useEmitterValue$1("stateRestoreInProgress");
  var listRef = useSize(function (el) {
    var scrollHeight = el.parentElement.parentElement.scrollHeight;
    scrollHeightCallback(scrollHeight);
    var firstItem = el.firstChild;
    if (firstItem) {
      var _firstItem$getBoundin = firstItem.getBoundingClientRect(),
        width = _firstItem$getBoundin.width,
        height = _firstItem$getBoundin.height;
      itemDimensions({
        width: width,
        height: height
      });
    }
    gridGap({
      row: resolveGapValue("row-gap", getComputedStyle(el).rowGap, log),
      column: resolveGapValue("column-gap", getComputedStyle(el).columnGap, log)
    });
  });
  if (stateRestoreInProgress) {
    return null;
  }
  return /*#__PURE__*/React.createElement(ListComponent, _objectSpread(_objectSpread({
    ref: listRef,
    className: listClassName
  }, contextPropIfNotDomElement(ListComponent, context)), {}, {
    style: {
      paddingTop: gridState.offsetTop,
      paddingBottom: gridState.offsetBottom
    },
    "data-test-id": "virtuoso-item-list"
  }), gridState.items.map(function (item) {
    var key = computeItemKey(item.index, item.data, context);
    return isSeeking ? /*#__PURE__*/React.createElement(ScrollSeekPlaceholder, _objectSpread(_objectSpread({
      key: key
    }, contextPropIfNotDomElement(ScrollSeekPlaceholder, context)), {}, {
      index: item.index,
      height: gridState.itemHeight,
      width: gridState.itemWidth
    })) : /*#__PURE__*/React.createElement(ItemComponent, _objectSpread(_objectSpread({}, contextPropIfNotDomElement(ItemComponent, context)), {}, {
      className: itemClassName,
      "data-index": item.index,
      key: key
    }), itemContent(item.index, item.data, context));
  }));
});
var Header = /*#__PURE__*/React.memo(function VirtuosoHeader2() {
  var Header2 = useEmitterValue$1("HeaderComponent");
  var headerHeight = usePublisher$1("headerHeight");
  var headerFooterTag = useEmitterValue$1("headerFooterTag");
  var ref = useSize(function (el) {
    return headerHeight(correctItemSize(el, "height"));
  });
  var context = useEmitterValue$1("context");
  return Header2 ? /*#__PURE__*/React.createElement(headerFooterTag, {
    ref: ref
  }, /*#__PURE__*/React.createElement(Header2, contextPropIfNotDomElement(Header2, context))) : null;
});
var Footer = /*#__PURE__*/React.memo(function VirtuosoGridFooter() {
  var Footer2 = useEmitterValue$1("FooterComponent");
  var footerHeight = usePublisher$1("footerHeight");
  var headerFooterTag = useEmitterValue$1("headerFooterTag");
  var ref = useSize(function (el) {
    return footerHeight(correctItemSize(el, "height"));
  });
  var context = useEmitterValue$1("context");
  return Footer2 ? /*#__PURE__*/React.createElement(headerFooterTag, {
    ref: ref
  }, /*#__PURE__*/React.createElement(Footer2, contextPropIfNotDomElement(Footer2, context))) : null;
});
var Viewport$1 = function Viewport$1(_ref233) {
  var children = _ref233.children;
  var ctx = React.useContext(VirtuosoGridMockContext);
  var itemDimensions = usePublisher$1("itemDimensions");
  var viewportDimensions = usePublisher$1("viewportDimensions");
  var viewportRef = useSize(function (el) {
    viewportDimensions(el.getBoundingClientRect());
  });
  React.useEffect(function () {
    if (ctx) {
      viewportDimensions({
        height: ctx.viewportHeight,
        width: ctx.viewportWidth
      });
      itemDimensions({
        height: ctx.itemHeight,
        width: ctx.itemWidth
      });
    }
  }, [ctx, viewportDimensions, itemDimensions]);
  return /* @__PURE__ */React.createElement("div", {
    style: viewportStyle,
    ref: viewportRef
  }, children);
};
var WindowViewport$1 = function WindowViewport$1(_ref234) {
  var children = _ref234.children;
  var ctx = React.useContext(VirtuosoGridMockContext);
  var windowViewportRect = usePublisher$1("windowViewportRect");
  var itemDimensions = usePublisher$1("itemDimensions");
  var customScrollParent = useEmitterValue$1("customScrollParent");
  var viewportRef = useWindowViewportRectRef(windowViewportRect, customScrollParent);
  React.useEffect(function () {
    if (ctx) {
      itemDimensions({
        height: ctx.itemHeight,
        width: ctx.itemWidth
      });
      windowViewportRect({
        offsetTop: 0,
        visibleHeight: ctx.viewportHeight,
        visibleWidth: ctx.viewportWidth
      });
    }
  }, [ctx, windowViewportRect, itemDimensions]);
  return /* @__PURE__ */React.createElement("div", {
    ref: viewportRef,
    style: viewportStyle
  }, children);
};
var GridRoot = /* @__PURE__ */React.memo(function GridRoot2(_ref235) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref235), _ref235));
  var useWindowScroll = useEmitterValue$1("useWindowScroll");
  var customScrollParent = useEmitterValue$1("customScrollParent");
  var TheScroller = customScrollParent || useWindowScroll ? WindowScroller$1 : Scroller$1;
  var TheViewport = customScrollParent || useWindowScroll ? WindowViewport$1 : Viewport$1;
  return /* @__PURE__ */React.createElement(TheScroller, _objectSpread({}, props), /* @__PURE__ */React.createElement(TheViewport, null, /* @__PURE__ */React.createElement(Header, null), /* @__PURE__ */React.createElement(GridItems, null), /* @__PURE__ */React.createElement(Footer, null)));
});
var _systemToComponent2 = /* @__PURE__ */systemToComponent(combinedSystem$1, {
    optional: {
      context: "context",
      totalCount: "totalCount",
      overscan: "overscan",
      itemContent: "itemContent",
      components: "components",
      computeItemKey: "computeItemKey",
      data: "data",
      initialItemCount: "initialItemCount",
      scrollSeekConfiguration: "scrollSeekConfiguration",
      headerFooterTag: "headerFooterTag",
      listClassName: "listClassName",
      itemClassName: "itemClassName",
      useWindowScroll: "useWindowScroll",
      customScrollParent: "customScrollParent",
      scrollerRef: "scrollerRef",
      logLevel: "logLevel",
      restoreStateFrom: "restoreStateFrom",
      initialTopMostItemIndex: "initialTopMostItemIndex"
    },
    methods: {
      scrollTo: "scrollTo",
      scrollBy: "scrollBy",
      scrollToIndex: "scrollToIndex"
    },
    events: {
      isScrolling: "isScrolling",
      endReached: "endReached",
      startReached: "startReached",
      rangeChanged: "rangeChanged",
      atBottomStateChange: "atBottomStateChange",
      atTopStateChange: "atTopStateChange",
      stateChanged: "stateChanged"
    }
  }, GridRoot),
  Grid = _systemToComponent2.Component,
  usePublisher$1 = _systemToComponent2.usePublisher,
  useEmitterValue$1 = _systemToComponent2.useEmitterValue,
  useEmitter$1 = _systemToComponent2.useEmitter;
var Scroller$1 = /* @__PURE__ */buildScroller({
  usePublisher: usePublisher$1,
  useEmitterValue: useEmitterValue$1,
  useEmitter: useEmitter$1
});
var WindowScroller$1 = /* @__PURE__ */buildWindowScroller({
  usePublisher: usePublisher$1,
  useEmitterValue: useEmitterValue$1,
  useEmitter: useEmitter$1
});
function resolveGapValue(property, value, log) {
  if (value !== "normal" && !(value == null ? void 0 : value.endsWith("px"))) {
    log("".concat(property, " was not resolved to pixel value correctly"), value, LogLevel.WARN);
  }
  if (value === "normal") {
    return 0;
  }
  return parseInt(value != null ? value : "0", 10);
}
var VirtuosoGrid = Grid;
var tableComponentPropsSystem = /* @__PURE__ */system(function () {
  var itemContent = statefulStream(function (index) {
    return /* @__PURE__ */React.createElement("td", null, "Item $", index);
  });
  var context = statefulStream(null);
  var fixedHeaderContent = statefulStream(null);
  var fixedFooterContent = statefulStream(null);
  var components = statefulStream({});
  var computeItemKey = statefulStream(identity);
  var scrollerRef = statefulStream(noop);
  var distinctProp = function distinctProp(propName) {
    var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return statefulStreamFromEmitter(pipe(components, map(function (components2) {
      return components2[propName];
    }), distinctUntilChanged()), defaultValue);
  };
  return {
    context: context,
    itemContent: itemContent,
    fixedHeaderContent: fixedHeaderContent,
    fixedFooterContent: fixedFooterContent,
    components: components,
    computeItemKey: computeItemKey,
    scrollerRef: scrollerRef,
    TableComponent: distinctProp("Table", "table"),
    TableHeadComponent: distinctProp("TableHead", "thead"),
    TableFooterComponent: distinctProp("TableFoot", "tfoot"),
    TableBodyComponent: distinctProp("TableBody", "tbody"),
    TableRowComponent: distinctProp("TableRow", "tr"),
    ScrollerComponent: distinctProp("Scroller", "div"),
    EmptyPlaceholder: distinctProp("EmptyPlaceholder"),
    ScrollSeekPlaceholder: distinctProp("ScrollSeekPlaceholder"),
    FillerRow: distinctProp("FillerRow")
  };
});
var combinedSystem = /* @__PURE__ */system(function (_ref236) {
  var _ref237 = _slicedToArray(_ref236, 2),
    listSystem2 = _ref237[0],
    propsSystem = _ref237[1];
  return _objectSpread(_objectSpread({}, listSystem2), propsSystem);
}, tup(listSystem, tableComponentPropsSystem));
var DefaultScrollSeekPlaceholder = function DefaultScrollSeekPlaceholder(_ref238) {
  var height = _ref238.height;
  return /* @__PURE__ */React.createElement("tr", null, /* @__PURE__ */React.createElement("td", {
    style: {
      height: height
    }
  }));
};
var DefaultFillerRow = function DefaultFillerRow(_ref239) {
  var height = _ref239.height;
  return /* @__PURE__ */React.createElement("tr", null, /* @__PURE__ */React.createElement("td", {
    style: {
      height: height,
      padding: 0,
      border: 0
    }
  }));
};
var ITEM_STYLE = {
  overflowAnchor: "none"
};
var Items = /* @__PURE__ */React.memo(function VirtuosoItems2() {
  var listState = useEmitterValue("listState");
  var sizeRanges = usePublisher("sizeRanges");
  var useWindowScroll = useEmitterValue("useWindowScroll");
  var customScrollParent = useEmitterValue("customScrollParent");
  var windowScrollContainerStateCallback = usePublisher("windowScrollContainerState");
  var _scrollContainerStateCallback = usePublisher("scrollContainerState");
  var scrollContainerStateCallback = customScrollParent || useWindowScroll ? windowScrollContainerStateCallback : _scrollContainerStateCallback;
  var itemContent = useEmitterValue("itemContent");
  var trackItemSizes = useEmitterValue("trackItemSizes");
  var itemSize = useEmitterValue("itemSize");
  var log = useEmitterValue("log");
  var _useChangedListConten2 = useChangedListContentsSizes(sizeRanges, itemSize, trackItemSizes, scrollContainerStateCallback, log, void 0, customScrollParent),
    callbackRef = _useChangedListConten2.callbackRef,
    ref = _useChangedListConten2.ref;
  var _React$useState9 = React.useState(0),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    deviation = _React$useState10[0],
    setDeviation = _React$useState10[1];
  useEmitter("deviation", function (value) {
    if (deviation !== value) {
      ref.current.style.marginTop = "".concat(value, "px");
      setDeviation(value);
    }
  });
  var EmptyPlaceholder = useEmitterValue("EmptyPlaceholder");
  var ScrollSeekPlaceholder = useEmitterValue("ScrollSeekPlaceholder") || DefaultScrollSeekPlaceholder;
  var FillerRow = useEmitterValue("FillerRow") || DefaultFillerRow;
  var TableBodyComponent = useEmitterValue("TableBodyComponent");
  var TableRowComponent = useEmitterValue("TableRowComponent");
  var computeItemKey = useEmitterValue("computeItemKey");
  var isSeeking = useEmitterValue("isSeeking");
  var paddingTopAddition = useEmitterValue("paddingTopAddition");
  var firstItemIndex = useEmitterValue("firstItemIndex");
  var statefulTotalCount = useEmitterValue("statefulTotalCount");
  var context = useEmitterValue("context");
  if (statefulTotalCount === 0 && EmptyPlaceholder) {
    return /*#__PURE__*/React.createElement(EmptyPlaceholder, contextPropIfNotDomElement(EmptyPlaceholder, context));
  }
  var paddingTop = listState.offsetTop + paddingTopAddition + deviation;
  var paddingBottom = listState.offsetBottom;
  var paddingTopEl = paddingTop > 0 ? /* @__PURE__ */React.createElement(FillerRow, {
    height: paddingTop,
    key: "padding-top",
    context: context
  }) : null;
  var paddingBottomEl = paddingBottom > 0 ? /* @__PURE__ */React.createElement(FillerRow, {
    height: paddingBottom,
    key: "padding-bottom",
    context: context
  }) : null;
  var items = listState.items.map(function (item) {
    var index = item.originalIndex;
    var key = computeItemKey(index + firstItemIndex, item.data, context);
    if (isSeeking) {
      return /*#__PURE__*/React.createElement(ScrollSeekPlaceholder, _objectSpread(_objectSpread({}, contextPropIfNotDomElement(ScrollSeekPlaceholder, context)), {}, {
        key: key,
        index: item.index,
        height: item.size,
        type: item.type || "item"
      }));
    }
    return /*#__PURE__*/React.createElement(TableRowComponent, _objectSpread(_objectSpread(_objectSpread({}, contextPropIfNotDomElement(TableRowComponent, context)), itemPropIfNotDomElement(TableRowComponent, item.data)), {}, {
      key: key,
      "data-index": index,
      "data-known-size": item.size,
      "data-item-index": item.index,
      style: ITEM_STYLE
    }), itemContent(item.index, item.data, context));
  });
  return /*#__PURE__*/React.createElement(TableBodyComponent, _objectSpread({
    ref: callbackRef,
    "data-test-id": "virtuoso-item-list"
  }, contextPropIfNotDomElement(TableBodyComponent, context)), [paddingTopEl].concat(_toConsumableArray(items), [paddingBottomEl]));
});
var Viewport = function Viewport(_ref240) {
  var children = _ref240.children;
  var ctx = React.useContext(VirtuosoMockContext);
  var viewportHeight = usePublisher("viewportHeight");
  var fixedItemHeight = usePublisher("fixedItemHeight");
  var viewportRef = useSize(compose(viewportHeight, function (el) {
    return correctItemSize(el, "height");
  }));
  React.useEffect(function () {
    if (ctx) {
      viewportHeight(ctx.viewportHeight);
      fixedItemHeight(ctx.itemHeight);
    }
  }, [ctx, viewportHeight, fixedItemHeight]);
  return /* @__PURE__ */React.createElement("div", {
    style: viewportStyle,
    ref: viewportRef,
    "data-viewport-type": "element"
  }, children);
};
var WindowViewport = function WindowViewport(_ref241) {
  var children = _ref241.children;
  var ctx = React.useContext(VirtuosoMockContext);
  var windowViewportRect = usePublisher("windowViewportRect");
  var fixedItemHeight = usePublisher("fixedItemHeight");
  var customScrollParent = useEmitterValue("customScrollParent");
  var viewportRef = useWindowViewportRectRef(windowViewportRect, customScrollParent);
  React.useEffect(function () {
    if (ctx) {
      fixedItemHeight(ctx.itemHeight);
      windowViewportRect({
        offsetTop: 0,
        visibleHeight: ctx.viewportHeight,
        visibleWidth: 100
      });
    }
  }, [ctx, windowViewportRect, fixedItemHeight]);
  return /* @__PURE__ */React.createElement("div", {
    ref: viewportRef,
    style: viewportStyle,
    "data-viewport-type": "window"
  }, children);
};
var TableRoot = /* @__PURE__ */React.memo(function TableVirtuosoRoot(props) {
  var useWindowScroll = useEmitterValue("useWindowScroll");
  var customScrollParent = useEmitterValue("customScrollParent");
  var fixedHeaderHeight = usePublisher("fixedHeaderHeight");
  var fixedFooterHeight = usePublisher("fixedFooterHeight");
  var fixedHeaderContent = useEmitterValue("fixedHeaderContent");
  var fixedFooterContent = useEmitterValue("fixedFooterContent");
  var context = useEmitterValue("context");
  var theadRef = useSize(compose(fixedHeaderHeight, function (el) {
    return correctItemSize(el, "height");
  }));
  var tfootRef = useSize(compose(fixedFooterHeight, function (el) {
    return correctItemSize(el, "height");
  }));
  var TheScroller = customScrollParent || useWindowScroll ? WindowScroller : Scroller;
  var TheViewport = customScrollParent || useWindowScroll ? WindowViewport : Viewport;
  var TheTable = useEmitterValue("TableComponent");
  var TheTHead = useEmitterValue("TableHeadComponent");
  var TheTFoot = useEmitterValue("TableFooterComponent");
  var theHead = fixedHeaderContent ? /*#__PURE__*/React.createElement(TheTHead, _objectSpread({
    key: "TableHead",
    style: {
      zIndex: 2,
      position: "sticky",
      top: 0
    },
    ref: theadRef
  }, contextPropIfNotDomElement(TheTHead, context)), fixedHeaderContent()) : null;
  var theFoot = fixedFooterContent ? /*#__PURE__*/React.createElement(TheTFoot, _objectSpread({
    key: "TableFoot",
    style: {
      zIndex: 1,
      position: "sticky",
      bottom: 0
    },
    ref: tfootRef
  }, contextPropIfNotDomElement(TheTFoot, context)), fixedFooterContent()) : null;
  return /* @__PURE__ */React.createElement(TheScroller, _objectSpread({}, props), /* @__PURE__ */React.createElement(TheViewport, null, /*#__PURE__*/React.createElement(TheTable, _objectSpread({
    style: {
      borderSpacing: 0,
      overflowAnchor: "none"
    }
  }, contextPropIfNotDomElement(TheTable, context)), [theHead, /* @__PURE__ */React.createElement(Items, {
    key: "TableBody"
  }), theFoot])));
});
var _systemToComponent3 = /* @__PURE__ */systemToComponent(combinedSystem, {
    required: {},
    optional: {
      restoreStateFrom: "restoreStateFrom",
      context: "context",
      followOutput: "followOutput",
      firstItemIndex: "firstItemIndex",
      itemContent: "itemContent",
      fixedHeaderContent: "fixedHeaderContent",
      fixedFooterContent: "fixedFooterContent",
      overscan: "overscan",
      increaseViewportBy: "increaseViewportBy",
      totalCount: "totalCount",
      topItemCount: "topItemCount",
      initialTopMostItemIndex: "initialTopMostItemIndex",
      components: "components",
      groupCounts: "groupCounts",
      atBottomThreshold: "atBottomThreshold",
      atTopThreshold: "atTopThreshold",
      computeItemKey: "computeItemKey",
      defaultItemHeight: "defaultItemHeight",
      fixedItemHeight: "fixedItemHeight",
      itemSize: "itemSize",
      scrollSeekConfiguration: "scrollSeekConfiguration",
      data: "data",
      initialItemCount: "initialItemCount",
      initialScrollTop: "initialScrollTop",
      alignToBottom: "alignToBottom",
      useWindowScroll: "useWindowScroll",
      customScrollParent: "customScrollParent",
      scrollerRef: "scrollerRef",
      logLevel: "logLevel"
    },
    methods: {
      scrollToIndex: "scrollToIndex",
      scrollIntoView: "scrollIntoView",
      scrollTo: "scrollTo",
      scrollBy: "scrollBy",
      getState: "getState"
    },
    events: {
      isScrolling: "isScrolling",
      endReached: "endReached",
      startReached: "startReached",
      rangeChanged: "rangeChanged",
      atBottomStateChange: "atBottomStateChange",
      atTopStateChange: "atTopStateChange",
      totalListHeightChanged: "totalListHeightChanged",
      itemsRendered: "itemsRendered",
      groupIndices: "groupIndices"
    }
  }, TableRoot),
  Table = _systemToComponent3.Component,
  usePublisher = _systemToComponent3.usePublisher,
  useEmitterValue = _systemToComponent3.useEmitterValue,
  useEmitter = _systemToComponent3.useEmitter;
var Scroller = /* @__PURE__ */buildScroller({
  usePublisher: usePublisher,
  useEmitterValue: useEmitterValue,
  useEmitter: useEmitter
});
var WindowScroller = /* @__PURE__ */buildWindowScroller({
  usePublisher: usePublisher,
  useEmitterValue: useEmitterValue,
  useEmitter: useEmitter
});
var TableVirtuoso = Table;
export { GroupedVirtuoso, LogLevel, TableVirtuoso, Virtuoso, VirtuosoGrid, VirtuosoGridMockContext, VirtuosoMockContext };